<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row v-if="acceso">
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Auditoría</span>
            <v-spacer></v-spacer>

            <v-btn
              class="mr-2"
              small
              dark
              color="green"
              @click="exportExcel(auditoriasExportables, nombreArchivoAuditorias)"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn color="orange" dark class="mr-2" @click="openDialogActivo" small tile>
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row justify="space-between">
              <v-col v-if="esTabEvaluacionPersonal" cols="12" md="4" lg="3">
                <label>Tipo de Auditoría</label>
                <v-select
                  :items="tiposAuditoria"
                  v-model="filtros.tipoAuditoria"
                  label="Selecciona tipo"
                  item-text="nombre"
                  item-value="nombre"
                  filled
                  dense
                  clearable
                  single-line
                ></v-select>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <label>Fecha inicio</label>
                <v-text-field
                  label="Fecha de inicio"
                  filled
                  dense
                  v-model="filtros.fechaini"
                  single-line
                  type="date"
                  :max="fechaMaxima"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <label>Fecha final</label>
                <v-text-field
                  label="Fecha final"
                  filled
                  dense
                  v-model="filtros.fechafin"
                  single-line
                  type="date"
                  :max="fechaMaxima"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <label>Selecciona el Colaborador</label>
                <v-autocomplete
                  :items="colaboradores"
                  v-model="filtros.colaborador"
                  label="Colaborador"
                  item-text="usuario_registro"
                  item-value="idusuario"
                  filled
                  dense
                  single-line
                  clearable
                  no-data-text="No hay datos"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <label>Selecciona el Departamento</label>
                <v-select
                  :items="departamentos"
                  v-model="filtros.departamento"
                  label="Departamento"
                  item-text="nombre"
                  item-value="id"
                  filled
                  dense
                  clearable
                  single-line
                  no-data-text="No hay datos"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <label>Selecciona el Plantel</label>
                <v-autocomplete
                  :items="planteles"
                  v-model="filtros.plantel"
                  label="Plantel"
                  item-text="plantel"
                  item-value="idplantel"
                  filled
                  dense
                  single-line
                  clearable
                  no-data-text="No hay datos"
                ></v-autocomplete>
              </v-col>

              <v-col v-if="esTabEvaluacionPersonal" cols="12" md="4" lg="3">
                <label>Estatus</label>
                <v-select
                  :items="estatusValidos"
                  v-model="filtros.estatus"
                  label="Estatus"
                  filled
                  dense
                  clearable
                  single-line
                  no-data-text="No hay datos"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4" lg="3">
                <v-text-field
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="filtros.search"
                  label="Buscar"
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="auditoria-dashboard mt-4">
              <template v-if="esTabEvaluacionPersonal">
                <div class="auditoria-dashboard-header">
                  <span class="auditoria-section-title">Reporte Evaluación Personal</span>
                  <template v-if="tarjetasReporteDepartamento.length">
                    <v-chip x-small class="auditoria-chip" color="blue lighten-5" text-color="blue darken-2">
                      Promedio: {{ formatPorcentaje(totalesReporteTarjetas.promedioResultado) }}
                    </v-chip>
                  </template>
                </div>

                <v-row v-if="tarjetasReporteDepartamento.length" dense class="reporte-dashboard-row">
                  <v-col
                    v-for="row in tarjetasReporteDepartamento"
                    :key="row.id_departamento || row.departamento"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-card flat class="reporte-dept-card pa-3">
                      <div class="text-body-2 font-weight-bold text-truncate">
                        {{ row.departamento }}
                      </div>
                      <div class="text-caption text--secondary mt-1">Estatus</div>
                      <div class="auditoria-metrics mt-2">
                        <div class="reporte-metric">
                          <span class="text-caption text--secondary">Inicial</span>
                          <span class="reporte-metric-val primary--text">{{ row.conteoInicial }}</span>
                        </div>
                        <div class="reporte-metric">
                          <span class="text-caption text--secondary">Seguimiento</span>
                          <span class="reporte-metric-val orange--text text--darken-2">
                            {{ row.conteoSeguimiento }}
                          </span>
                        </div>
                        <div class="reporte-metric">
                          <span class="text-caption text--secondary">Promedio</span>
                          <span class="reporte-metric-val teal--text text--darken-2">
                            {{ formatPorcentaje(row.promedioResultado) }}
                          </span>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <div
                  v-else
                  class="text-caption text--secondary py-1 d-flex align-center flex-wrap"
                  style="gap: 8px;"
                >
                  Sin datos de reporte.
                  <v-btn color="primary" @click="initialize" x-small text>Actualizar</v-btn>
                </div>
              </template>

              <template v-else>
                <div class="auditoria-dashboard-header">
                  <span class="auditoria-section-title">Reporte Control Interno</span>
                  <template v-if="tarjetasReporteControlInterno.length">
                    <v-chip x-small class="auditoria-chip" color="blue lighten-5" text-color="blue darken-2">
                      Auditorías: {{ totalesReporteControlInterno.totalAuditorias }}
                    </v-chip>
                    <v-chip x-small class="auditoria-chip" color="teal lighten-5" text-color="teal darken-2">
                      Planteles: {{ totalesReporteControlInterno.totalPlanteles }}
                    </v-chip>
                  </template>
                </div>

                <v-row v-if="tarjetasReporteControlInterno.length" dense class="reporte-dashboard-row">
                  <v-col
                    v-for="row in tarjetasReporteControlInterno"
                    :key="row.id_departamento || row.departamento"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-card flat class="reporte-dept-card pa-3">
                      <div class="text-body-2 font-weight-bold text-truncate">
                        {{ row.departamento }}
                      </div>
                      <div class="text-caption text--secondary mt-1">Control Interno</div>
                      <div class="auditoria-metrics mt-2">
                        <div class="reporte-metric">
                          <span class="text-caption text--secondary">Auditorías</span>
                          <span class="reporte-metric-val primary--text">{{ row.totalAuditorias }}</span>
                        </div>
                        <div class="reporte-metric">
                          <span class="text-caption text--secondary">Planteles</span>
                          <span class="reporte-metric-val orange--text text--darken-2">
                            {{ row.totalPlanteles }}
                          </span>
                        </div>
                        <div class="reporte-metric">
                          <span class="text-caption text--secondary">Responsables</span>
                          <span class="reporte-metric-val teal--text text--darken-2">
                            {{ row.totalResponsables }}
                          </span>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <div
                  v-else
                  class="text-caption text--secondary py-1 d-flex align-center flex-wrap"
                  style="gap: 8px;"
                >
                  Sin datos de control interno.
                  <v-btn color="primary" @click="openDialogActivo" x-small text>Agregar auditoría</v-btn>
                </div>
              </template>
            </div>

            <div class="auditoria-tabs-wrap">
              <v-tabs
                v-model="auditoriaTab"
                class="auditoria-tabs"
                background-color="transparent"
                height="40"
                slider-color="primary"
              >
                <v-tab class="auditoria-tab auditoria-tab--evaluacion" active-class="auditoria-tab--active">
                  Evaluación Personal
                </v-tab>
                <v-tab class="auditoria-tab auditoria-tab--control" active-class="auditoria-tab--active">
                  Control Interno
                </v-tab>
              </v-tabs>
            </div>

            <div class="auditoria-table-header">
              <span class="auditoria-section-title">{{ tituloTablaActiva }}</span>
              <span class="text-caption text--secondary">
                {{ auditoriasExportables.length }} registros
              </span>
            </div>
            <v-row>
              <v-col cols="12">
                <v-tabs-items v-model="auditoriaTab">
                  <v-tab-item>
                    <v-data-table
                      :headers="headers"
                      :items="auditoriasFiltradas"
                      class="auditoria-table elevation-0"
                      :mobile-breakpoint="100"
                      :loading="cargandoAuditorias"
                      loading-text="Cargando datos"
                      dense
                    >
                      <template v-slot:item.tipoAuditoria="{ item }">
                        <v-chip small :color="getTipoColor(item.tipoAuditoria)" dark>
                          {{ item.tipoAuditoria }}
                        </v-chip>
                      </template>

                      <template v-slot:item.estatus="{ item }">
                        <v-chip
                          small
                          dark
                          :color="
                            item.estatus === 'Aceptada'
                              ? 'green'
                              : item.estatus === 'Rechazada'
                                ? 'black'
                                : 'blue'
                          "
                        >
                          {{ item.estatus }}
                        </v-chip>
                      </template>

                      <template v-slot:item.resultadoPorcentaje="{ item }">
                        {{ formatPorcentaje(item.resultadoPorcentaje) }}
                      </template>

                      <template v-slot:item.actions="{ item }">
                        <v-btn color="primary" x-small @click="editItem(item)" class="mr-2">
                          <v-icon small>mdi-magnify</v-icon>
                        </v-btn>

                        <v-btn
                          color="error"
                          x-small
                          @click="deleteItem(item)"
                          v-if="canDelete(item)"
                          class="mr-2"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>

                      <template v-slot:no-data>
                        <div v-if="cargandoAuditorias" class="py-6 text-body-2 text--secondary">
                          Cargando datos
                        </div>
                        <div v-else class="py-2">
                          <span class="text-body-2 text--secondary">No hay datos</span>
                          <v-btn color="primary" @click="initialize" small class="ml-2">
                            Actualizar
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-tab-item>

                  <v-tab-item>
                    <v-data-table
                      :headers="headersControlInterno"
                      :items="controlInternoFiltradas"
                      class="auditoria-table elevation-0"
                      :mobile-breakpoint="100"
                      dense
                    >
                      <template v-slot:item.fechaAuditoria="{ item }">
                        {{ item.fechaAuditoria || '-' }}
                      </template>

                      <template v-slot:item.actions="{ item }">
                        <v-btn color="primary" x-small @click="editControlInternoItem(item)" class="mr-2">
                          <v-icon small>mdi-magnify</v-icon>
                        </v-btn>

                        <v-btn
                          color="error"
                          x-small
                          @click="deleteControlInternoItem(item)"
                          v-if="canDelete(item)"
                          class="mr-2"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>

                      <template v-slot:no-data>
                        <div class="py-2">
                          <span class="text-body-2 text--secondary">No hay datos</span>
                          <v-btn color="primary" @click="openDialogActivo" small class="ml-2">
                            Agregar
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="1100px" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1" v-if="editedItem.id">
            <strong>ID: {{ editedItem.id }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <h3 class="mb-2">I. Información general</h3>
              <v-divider class="mb-4"></v-divider>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Departamento/Área:</label>
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.departamento"
                :items="departamentos"
                label="Selecciona departamento o área"
                item-text="nombre"
                item-value="id"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Fecha de Auditoría:</label>
              <v-text-field
                type="date"
                filled
                dense
                :max="fechaMaxima"
                v-model="editedItem.fecha"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Proceso Auditado:</label>
              <v-select
                v-model="editedItem.tipoAuditoria"
                :items="tiposAuditoria"
                item-text="nombre"
                item-value="nombre"
                filled
                dense
                clearable
                label="Tipo de Auditoría"
                no-data-text="No hay datos"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Auditor:</label>
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.auditor"
                :items="usuariosSelects"
                label="Selecciona auditor"
                item-text="usuario_registro"
                item-value="idusuario"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Jefe de departamento:</label>
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.jefeDepartamento"
                :items="usuariosSoloCatalogoErp"
                label="Seleccionar jefe de departamento"
                :item-text="etiquetaUsuarioSelect"
                item-value="idusuario"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Estatus:</label>
              <v-radio-group v-model="editedItem.estatusModalidad" row class="mt-0" hide-details>
                <v-radio label="Inicial" value="Inicial"></v-radio>
                <v-radio label="Seguimiento" value="Seguimiento"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" class="mt-2">
              <h3 class="mb-3">II. Lista de verificación universal (PHVA)</h3>
              <v-simple-table dense class="phva-table elevation-1">
                <thead>
                  <tr>
                    <th class="text-left">Criterio de evaluación</th>
                    <th style="width: 200px">Calificación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fila in criteriosPhvaFilasTabla" :key="fila._key">
                    <template v-if="fila.kind === 'header'">
                      <td colspan="2" class="grey lighten-4 font-weight-bold py-2">{{ fila.titulo }}</td>
                    </template>
                    <template v-else-if="fila.kind === 'row'">
                      <td>
                        <div class="font-weight-bold">{{ fila.c.idVisual || fila.c.id }}</div>
                        <div class="mt-1">{{ etiquetaPreguntaPhva(fila.c) }}</div>
                      </td>
                      <td>
                        <v-select
                          v-model="fila.c.calificacion"
                          :items="calificacionesPhvaSelect"
                          item-text="text"
                          item-value="value"
                          label="Calificación"
                          dense
                          filled
                          hide-details
                          clearable
                        ></v-select>
                      </td>
                    </template>
                    <template v-else-if="fila.kind === 'evidencia-general'">
                      <td colspan="2" class="bg-light-grey pa-3">
                        <div class="font-weight-bold mb-2">Evidencia / Hallazgo General</div>
                        <v-textarea
                          v-model="evidenciasGeneralesPhva[fila.seccion]"
                          dense
                          filled
                          rows="3"
                          hide-details
                          placeholder="Evidencia/Hallazgo general para esta sección"
                        ></v-textarea>
                        <div class="mt-3">
                          <v-file-input
                            accept="image/*"
                            dense
                            filled
                            hide-details
                            prepend-icon="mdi-camera"
                            label="Subir foto"
                            @change="onFotoEvidenciaGeneralChange(fila.seccion, $event)"
                          ></v-file-input>
                          <div v-if="obtenerFotoEvidenciaGeneral(fila.seccion)" class="mt-2">
                            <v-img
                              :src="obtenerFotoEvidenciaGeneral(fila.seccion)"
                              max-height="150"
                              contain
                              class="grey lighten-4"
                            ></v-img>
                            <v-btn x-small text color="error" class="mt-1" @click="quitarFotoEvidenciaGeneral(fila.seccion)">
                              Quitar foto
                            </v-btn>
                          </div>
                        </div>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>

            <v-col cols="12" class="mt-4">
              <h3 class="mb-2">III. Resumen de hallazgos (Caja de texto/comentario)</h3>
              <v-divider class="mb-3"></v-divider>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.hallazgo1"
                    filled
                    dense
                    hide-details
                    label="1."
                    placeholder="Escribe el hallazgo principal"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.hallazgo2"
                    filled
                    dense
                    hide-details
                    label="2."
                    placeholder="Escribe el segundo hallazgo"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.hallazgo3"
                    filled
                    dense
                    hide-details
                    label="3."
                    placeholder="Escribe el tercer hallazgo"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="mt-4">
              <h3 class="mb-2">
                IV. Plan de acción y cierre (Esto lo tiene que poder llenar el auditor o jefe de control interno y el responsable del departamento)
              </h3>
              <v-divider class="mb-3"></v-divider>

              <v-row>
                <v-col cols="12" md="6">
                  <label class="text-body-2">Acción correctiva:</label>
                  <v-textarea
                    v-model="editedItem.accionCorrectiva"
                    filled
                    dense
                    rows="3"
                    auto-grow
                    hide-details
                    placeholder="Describe la acción correctiva"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" md="6">
                  <label class="text-body-2">Responsable:</label>
                  <v-autocomplete
                    filled
                    dense
                    clearable
                    v-model="editedItem.responsable"
                    :items="usuariosSoloCatalogoErp"
                    label="Seleccionar responsable"
                    :item-text="etiquetaUsuarioSelect"
                    item-value="iderp"
                    no-data-text="No hay datos"
                  ></v-autocomplete>

                  <label class="text-body-2">Fecha de compromiso:</label>
                  <v-text-field
                    type="date"
                    filled
                    dense
                    v-model="editedItem.fechaCompromiso"
                    :min="editedItem.fecha || null"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn color="black" tile dark small @click="close">
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" tile dark small @click="save">
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogControlInterno" max-width="1180px" persistent scrollable>
      <v-card class="control-interno-modal-card">
        <v-card-title class="control-interno-modal-header">
          <div class="control-interno-modal-title-wrap">
            <div class="control-interno-modal-icon">
              <v-icon color="primary">mdi-shield-check</v-icon>
            </div>
            <div>
              <span class="control-interno-modal-title">{{ controlInternoFormTitle }}</span>
              <div class="control-interno-modal-subtitle">
                Auditoría operativa del plantel y seguimiento de control interno
              </div>
            </div>
          </div>
          <v-spacer></v-spacer>
          <span class="control-interno-modal-id" v-if="editedControlInternoItem.id">
            <strong>ID: {{ editedControlInternoItem.id }}</strong>
          </span>
        </v-card-title>

        <v-card-text class="control-interno-modal-body">
          <div class="control-interno-modal-dashboard">
            <div class="control-interno-modal-stat">
              <span class="stat-label">Plantel</span>
              <span class="stat-value">
                {{ nombrePlantel(editedControlInternoItem.idplantel, 'Pendiente') || 'Pendiente' }}
              </span>
            </div>
            <div class="control-interno-modal-stat">
              <span class="stat-label">Fecha</span>
              <span class="stat-value">{{ editedControlInternoItem.fechaAuditoria || 'Sin fecha' }}</span>
            </div>
            <div class="control-interno-modal-stat">
              <span class="stat-label">Avance checklist</span>
              <span class="stat-value">
                {{ resumenControlInternoModal.completados }}/{{ resumenControlInternoModal.total }}
              </span>
            </div>
            <div class="control-interno-modal-stat stat-accent">
              <span class="stat-label">Secciones</span>
              <span class="stat-value">7</span>
            </div>
          </div>

          <v-row>
            <v-col cols="12">
              <h3 class="mb-2">I. Información de Control Interno</h3>
              <v-divider class="mb-4"></v-divider>
            </v-col>

            <v-col cols="12">
              <label class="text-body-2">Objetivo:</label>
              <v-textarea
                v-model="editedControlInternoItem.objetivo"
                filled
                dense
                rows="3"
                auto-grow
                placeholder="Describe el objetivo de la auditoría"
              ></v-textarea>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Departamento:</label>
              <v-autocomplete
                v-model="editedControlInternoItem.departamento"
                :items="departamentos"
                filled
                dense
                clearable
                label="Selecciona departamento"
                item-text="nombre"
                item-value="id"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Dirigido a:</label>
              <v-autocomplete
                v-model="editedControlInternoItem.dirigidoA"
                :items="usuariosSelects"
                filled
                dense
                clearable
                label="Selecciona colaborador"
                :item-text="etiquetaUsuarioSelect"
                item-value="idusuario"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Plantel:</label>
              <v-autocomplete
                v-model="editedControlInternoItem.idplantel"
                :items="planteles"
                filled
                dense
                clearable
                label="Selecciona plantel"
                item-text="plantel"
                item-value="idplantel"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Responsable del plantel:</label>
              <v-autocomplete
                v-model="editedControlInternoItem.responsablePlantel"
                :items="usuariosSoloCatalogoErp"
                filled
                dense
                clearable
                label="Selecciona responsable"
                :item-text="etiquetaUsuarioSelect"
                item-value="iderp"
                no-data-text="No hay datos"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <label class="text-body-2">Fecha de auditoría:</label>
              <v-text-field
                v-model="editedControlInternoItem.fechaAuditoria"
                type="date"
                filled
                dense
                :max="fechaMaxima"
              ></v-text-field>
            </v-col>

            <v-col cols="12" class="mt-2">
              <h3 class="mb-2">II. Lista de verificación</h3>
              <v-divider class="mb-3"></v-divider>

              <div class="control-interno-seccion-title">1. INSTALACIONES</div>
              <v-simple-table dense class="control-interno-check-table">
                <thead>
                  <tr>
                    <th class="text-left">Criterio</th>
                    <th class="text-center">Cumple</th>
                    <th class="text-center">No cumple</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="criterio in editedControlInternoItem.criterios" :key="criterio.id">
                    <td>{{ criterio.criterio }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'Cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'No cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <div class="control-interno-seccion-title mt-5">
                2. AUDITORÍA DE SALONES (Total de salones: {{ editedControlInternoItem.salones.length }})
              </div>
              <v-simple-table dense class="control-interno-check-table">
                <thead>
                  <tr>
                    <th class="text-center">Salón</th>
                    <th class="text-center">Bancos</th>
                    <th class="text-center">Proyector</th>
                    <th class="text-center">Iluminación</th>
                    <th class="text-center">Clima (A/C)</th>
                    <th class="text-center">Pintura</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="salon in editedControlInternoItem.salones" :key="salon.salon">
                    <td class="text-center font-weight-bold">{{ salon.salon }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="salon.bancos"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(salon, 'bancos')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="salon.proyector"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(salon, 'proyector')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="salon.iluminacion"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(salon, 'iluminacion')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="salon.clima"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(salon, 'clima')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="salon.pintura"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(salon, 'pintura')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.observacionesSalones"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>

              <div class="control-interno-seccion-title mt-5">3. CORTE</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <label class="text-body-2 font-weight-bold">Encargada:</label>
                  <v-autocomplete
                    v-model="editedControlInternoItem.corte.encargada"
                    :items="usuariosSelects"
                    :item-text="etiquetaUsuarioSelect"
                    item-value="idusuario"
                    dense
                    filled
                    clearable
                    hide-details
                    no-data-text="No hay datos"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <label class="text-body-2 font-weight-bold">Recepción en turno:</label>
                  <v-autocomplete
                    v-model="editedControlInternoItem.corte.recepcionTurno"
                    :items="usuariosSelects"
                    :item-text="etiquetaUsuarioSelect"
                    item-value="idusuario"
                    dense
                    filled
                    clearable
                    hide-details
                    no-data-text="No hay datos"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-simple-table dense class="control-interno-check-table mt-3">
                <thead>
                  <tr>
                    <th class="text-left">Criterio</th>
                    <th class="text-center">Cumple</th>
                    <th class="text-center">No cumple</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="criterio in editedControlInternoItem.corte.criterios" :key="criterio.id">
                    <td>{{ criterio.criterio }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'Cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'No cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.corte.observaciones"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>

              <div class="control-interno-seccion-title mt-5">4. CÓDIGO DE VESTIMENTA Y PUNTUALIDAD</div>
              <v-simple-table dense class="control-interno-check-table">
                <thead>
                  <tr>
                    <th class="text-left">Personal</th>
                    <th class="text-center">Uniforme correcto</th>
                    <th class="text-center">Presentación profesional</th>
                    <th class="text-center">Cumple horario</th>
                    <th class="text-center">Permanece en área</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="fila in editedControlInternoItem.vestimenta.filas" :key="fila.personal">
                    <td class="font-weight-bold">{{ fila.personal }}</td>
                    <td
                      v-for="campo in ['uniformeCorrecto', 'presentacionProfesional', 'cumpleHorario', 'permaneceArea']"
                      :key="campo"
                      class="text-center"
                    >
                      <v-checkbox
                        :input-value="fila[campo]"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="toggleBooleanControlInterno(fila, campo)"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.vestimenta.observaciones"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>

              <div class="control-interno-seccion-title mt-5">5. REINSCRIPCIONES (RI) Y ATENCIÓN AL ALUMNO</div>
              <label class="text-body-2 font-weight-bold">Encargada:</label>
              <v-text-field
                v-model="editedControlInternoItem.riAtencionAlumno.encargada"
                dense
                filled
                hide-details
                class="mb-3"
              ></v-text-field>
              <v-simple-table dense class="control-interno-check-table">
                <thead>
                  <tr>
                    <th class="text-left">Criterio</th>
                    <th class="text-center">Cumple</th>
                    <th class="text-center">No cumple</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="criterio in editedControlInternoItem.riAtencionAlumno.encargadaCriterios" :key="criterio.id">
                    <td>{{ criterio.criterio }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'Cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'No cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.riAtencionAlumno.encargadaObservaciones"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>

              <div class="font-weight-bold mt-4 mb-1">Recepción</div>
              <v-simple-table dense class="control-interno-check-table">
                <thead>
                  <tr>
                    <th class="text-left">Criterio</th>
                    <th class="text-center">Cumple</th>
                    <th class="text-center">No cumple</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="criterio in editedControlInternoItem.riAtencionAlumno.recepcionCriterios" :key="criterio.id">
                    <td>{{ criterio.criterio }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'Cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'No cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <label class="text-body-2 font-weight-bold mt-2 d-block">Observaciones:</label>
              <v-textarea
                v-model="editedControlInternoItem.riAtencionAlumno.recepcionObservaciones"
                dense
                filled
                rows="2"
                auto-grow
                hide-details
              ></v-textarea>

              <div class="control-interno-seccion-title mt-5">6. METODOLOGÍA 5S</div>
              <v-simple-table dense class="control-interno-check-table control-interno-table-wide">
                <thead>
                  <tr>
                    <th class="text-left">Pilar</th>
                    <th class="text-left">Criterio de revisión</th>
                    <th class="text-center">Cumple</th>
                    <th class="text-center">No</th>
                    <th class="text-left">Evidencia / Acción requerida</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="criterio in editedControlInternoItem.metodologia5s.criterios" :key="criterio.id">
                    <td class="font-weight-bold">{{ criterio.pilar }}</td>
                    <td>{{ criterio.criterioRevision }}</td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'Cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'Cumple')"
                      ></v-checkbox>
                    </td>
                    <td class="text-center">
                      <v-checkbox
                        :input-value="criterio.resultado === 'No cumple'"
                        class="control-interno-check"
                        hide-details
                        dense
                        @change="marcarCriterioControlInterno(criterio, 'No cumple')"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-textarea
                        v-model="criterio.evidenciaAccion"
                        dense
                        rows="2"
                        auto-grow
                        hide-details
                        solo
                        flat
                      ></v-textarea>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <div class="control-interno-nivel mt-3">
                <div
                  v-for="grupo in nivelGeneralControlInternoGrupos"
                  :key="grupo.campo"
                  class="control-interno-nivel-row"
                >
                  <strong>{{ grupo.label }}:</strong>
                  <v-checkbox
                    v-for="opcion in grupo.opciones"
                    :key="opcion"
                    :label="opcion"
                    :input-value="editedControlInternoItem.metodologia5s[grupo.campo] === opcion"
                    class="control-interno-check control-interno-nivel-check"
                    hide-details
                    dense
                    @change="seleccionarValorControlInterno(editedControlInternoItem.metodologia5s, grupo.campo, opcion)"
                  ></v-checkbox>
                </div>
              </div>

              <div class="control-interno-seccion-title mt-5">7. CIERRE DE AUDITORÍA</div>
              <p class="mb-2">
                Agradezco mucho el apoyo y las facilidades brindadas durante la revisión. Se realizó la validación de
                los distintos procesos y áreas del plantel conforme a lo establecido. Cualquier seguimiento adicional se
                estará revisando de manera interna.
              </p>
              <p class="mb-3">Quedo atenta a cualquier duda.</p>

              <div class="font-weight-bold mb-1">Principales hallazgos:</div>
              <v-simple-table dense class="control-interno-check-table control-interno-observaciones-table">
                <thead>
                  <tr>
                    <th>Observación</th>
                    <th>Departamento correspondiente</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(fila, index) in editedControlInternoItem.cierreAuditoria.principalesHallazgos" :key="index">
                    <td><v-text-field v-model="fila.observacion" dense hide-details solo flat></v-text-field></td>
                    <td>
                      <v-autocomplete
                        v-model="fila.departamento"
                        :items="departamentos"
                        item-text="nombre"
                        item-value="nombre"
                        dense
                        hide-details
                        solo
                        flat
                        clearable
                        no-data-text="No hay datos"
                      ></v-autocomplete>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <div class="font-weight-bold mt-3 mb-1">Áreas de oportunidad:</div>
              <v-simple-table dense class="control-interno-check-table control-interno-observaciones-table">
                <thead>
                  <tr>
                    <th>Observación</th>
                    <th>Departamento correspondiente</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(fila, index) in editedControlInternoItem.cierreAuditoria.areasOportunidad" :key="index">
                    <td><v-text-field v-model="fila.observacion" dense hide-details solo flat></v-text-field></td>
                    <td>
                      <v-autocomplete
                        v-model="fila.departamento"
                        :items="departamentos"
                        item-text="nombre"
                        item-value="nombre"
                        dense
                        hide-details
                        solo
                        flat
                        clearable
                        no-data-text="No hay datos"
                      ></v-autocomplete>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <div class="font-weight-bold mt-3 mb-1">Fortalezas detectadas:</div>
              <v-simple-table dense class="control-interno-check-table control-interno-observaciones-table">
                <thead>
                  <tr>
                    <th>Observación</th>
                    <th>Departamento correspondiente</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(fila, index) in editedControlInternoItem.cierreAuditoria.fortalezasDetectadas" :key="index">
                    <td><v-text-field v-model="fila.observacion" dense hide-details solo flat></v-text-field></td>
                    <td>
                      <v-autocomplete
                        v-model="fila.departamento"
                        :items="departamentos"
                        item-text="nombre"
                        item-value="nombre"
                        dense
                        hide-details
                        solo
                        flat
                        clearable
                        no-data-text="No hay datos"
                      ></v-autocomplete>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <div class="control-interno-firmas mt-4">
                <div class="font-weight-bold mb-2">FIRMAS</div>
                <v-row dense>
                  <v-col cols="12" md="4">
                    <label class="text-body-2 font-weight-bold">Auditor:</label>
                    <v-autocomplete
                      v-model="editedControlInternoItem.cierreAuditoria.auditorFirma"
                      :items="usuariosSelects"
                      :item-text="etiquetaUsuarioSelect"
                      item-value="idusuario"
                      dense
                      filled
                      clearable
                      hide-details
                      no-data-text="No hay datos"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <label class="text-body-2 font-weight-bold">Responsable del plantel:</label>
                    <v-autocomplete
                      v-model="editedControlInternoItem.cierreAuditoria.responsablePlantelFirma"
                      :items="usuariosSoloCatalogoErp"
                      :item-text="etiquetaUsuarioSelect"
                      item-value="iderp"
                      dense
                      filled
                      clearable
                      hide-details
                      no-data-text="No hay datos"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <label class="text-body-2 font-weight-bold">Fecha:</label>
                    <v-text-field
                      v-model="editedControlInternoItem.cierreAuditoria.fechaFirma"
                      type="date"
                      dense
                      filled
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="control-interno-modal-actions">
          <v-btn color="black" tile dark small class="control-interno-action-btn" @click="closeControlInterno">
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" tile dark small class="control-interno-action-btn" @click="saveControlInterno">
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'

const TIPOS_AUDITORIA = [
  { id: 1, nombre: 'Inicial' },
  { id: 2, nombre: 'Seguimiento' }
]

const ESTATUS_VALIDOS = ['Inicial', 'Seguimiento']
const CALIFICACIONES_VALIDAS = ['1 - No cumple', '2 - Parcial', '3 - Cumple totalmente', 'N/A']
const EVIDENCIA_FOTO_MARKER = '[FOTO_BASE64]'

const CRITERIOS_BASE = [
  {
    id: 1,
    idVisual: '1.1',
    seccion: '1.0 PLANIFICACIÓN (Documentación)',
    nombre: '¿Existe un diagrama de flujo o manual actualizado del proceso?',
    descripcion: ''
  },
  {
    id: 2,
    idVisual: '1.2',
    seccion: '1.0 PLANIFICACIÓN (Documentación)',
    nombre: '¿El personal conoce sus responsabilidades dentro del flujo?',
    descripcion: ''
  },
  {
    id: 3,
    idVisual: '2.1',
    seccion: '2.0 EJECUCIÓN (Trazabilidad)',
    nombre: '¿Se cuenta con evidencia (firmas, documentos, tickets) de cada paso?',
    descripcion: ''
  },
  {
    id: 4,
    idVisual: '2.2',
    seccion: '2.0 EJECUCIÓN (Trazabilidad)',
    nombre: '¿Los tiempos de ejecución coinciden con los estándares establecidos?',
    descripcion: ''
  },
  {
    id: 5,
    idVisual: '2.3',
    seccion: '2.0 EJECUCIÓN (Trazabilidad)',
    nombre: '¿El entorno de trabajo cumple con el estándar de orden (5S)?',
    descripcion: ''
  },
  {
    id: 6,
    idVisual: '3.1',
    seccion: '3.0 VERIFICACIÓN (Puntos de Control)',
    nombre: '¿Se realizan las validaciones/autorizaciones previas al cierre?',
    descripcion: ''
  },
  {
    id: 7,
    idVisual: '3.2',
    seccion: '3.0 VERIFICACIÓN (Puntos de Control)',
    nombre: '¿Se miden indicadores de desempeño (KPIs) en este proceso?',
    descripcion: ''
  },
  {
    id: 8,
    idVisual: '4.1',
    seccion: '4.0 ACTUACIÓN (Mejora)',
    nombre: '¿Se han corregido errores detectados en auditorías previas?',
    descripcion: ''
  },
  {
    id: 9,
    idVisual: '4.2',
    seccion: '4.0 ACTUACIÓN (Mejora)',
    nombre: '¿Existen propuestas documentadas para optimizar el proceso?',
    descripcion: ''
  }
]

const CRITERIOS_CONTROL_INTERNO_BASE = [
  {
    id: 1,
    seccion: '1. INSTALACIONES',
    criterio: 'Fachada (limpieza, buena imagen)'
  },
  {
    id: 2,
    seccion: '1. INSTALACIONES',
    criterio: 'Baños (limpieza, insumos, funcionamiento)'
  },
  {
    id: 3,
    seccion: '1. INSTALACIONES',
    criterio: 'Salones (condiciones generales)'
  },
  {
    id: 4,
    seccion: '1. INSTALACIONES',
    criterio: 'Recepción (equipo funcionando correctamente, espacio limpio y ordenado)'
  },
  {
    id: 5,
    seccion: '1. INSTALACIONES',
    criterio: 'Estado general de mantenimiento (desgaste, daños visibles)'
  }
]

const SALONES_CONTROL_INTERNO_BASE = [1, 2, 3, 4, 5].map((salon) => ({
  salon,
  bancos: false,
  proyector: false,
  iluminacion: false,
  clima: false,
  pintura: false
}))

const CORTE_CONTROL_INTERNO_BASE = [
  '(Encargada) Supervisión de cortes',
  '(Encargada) Validación de ingresos y egresos',
  '(Encargada) Control de incidencias',
  '(Recepción) Corte realizado y enviado correctamente',
  '(Recepción) Coincidencia de ingresos y egresos',
  '(Recepción) Control de recibos y pagos'
].map((criterio, index) => ({ id: index + 1, criterio, resultado: null }))

const VESTIMENTA_CONTROL_INTERNO_BASE = ['Encargada', 'Recepción', 'Staff Extra'].map((personal) => ({
  personal,
  uniformeCorrecto: false,
  presentacionProfesional: false,
  cumpleHorario: false,
  permaneceArea: false
}))

const RI_ENCARGADA_CONTROL_INTERNO_BASE = [
  'Seguimiento a actividades de recepción (mensajes, tickets, seguimiento académico)',
  'Supervisión de atención en tiempo y forma',
  'Supervisión de calidad en atención al cliente'
].map((criterio, index) => ({ id: index + 1, criterio, resultado: null }))

const RI_RECEPCION_CONTROL_INTERNO_BASE = [
  'Atención de mensajes en tiempo y forma',
  'Atención correcta de tickets',
  'Seguimiento a alumnos (académico y reprobados)',
  'Registro y atención de comentarios en panel',
  'Atención al cliente cordial y efectiva'
].map((criterio, index) => ({ id: index + 1, criterio, resultado: null }))

const METODOLOGIA_5S_CONTROL_INTERNO_BASE = [
  {
    id: 1,
    pilar: '1. Seiri (Clasificación)',
    criterioRevision: 'No hay objetos o documentos innecesarios en las áreas de trabajo.'
  },
  {
    id: 2,
    pilar: '2. Seiton (Orden)',
    criterioRevision: 'Todo equipo, insumo y archivo tiene un lugar asignado e identificado.'
  },
  {
    id: 3,
    pilar: '3. Seiso (Limpieza)',
    criterioRevision: 'Áreas operativas libres de polvo, basura o derrames.'
  },
  {
    id: 4,
    pilar: '4. Seiketsu (Estandarización)',
    criterioRevision: 'Existen ayudas visuales o señalamientos claros; se siguen los procesos.'
  },
  {
    id: 5,
    pilar: '5. Shitsuke (Disciplina)',
    criterioRevision: 'El equipo respeta y mantiene las 4S anteriores proactivamente.'
  }
].map((item) => ({ ...item, resultado: null, evidenciaAccion: '' }))

const NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES = {
  nivelGeneral: ['Óptimo', 'Funcional', 'Crítico'],
  climaGeneral: ['Positivo', 'Neutro', 'Negativo'],
  comunicacion: ['Buena', 'Regular', 'Deficiente'],
  organizacionTurnos: ['Clara', 'Parcial', 'Deficiente'],
  liderazgo: ['Adecuado', 'Área de mejora', 'Deficiente'],
  operacion: ['Sólida', 'Con fallas', 'Crítica']
}

function crearDefaultItem() {
  return {
    id: null,
    departamento: null,
    idplantel: null,
    tipoAuditoria: null,
    auditor: null,
    jefeDepartamento: null,
    fecha: null,
    estatus: 'Inicial',
    estatusModalidad: 'Inicial',
    procesoAuditado: '',
    hallazgos: '',
    hallazgo1: '',
    hallazgo2: '',
    hallazgo3: '',
    accionCorrectiva: '',
    responsable: null,
    fechaCompromiso: null,
    evidenciaCierre: ''
  }
}

function crearDefaultControlInternoItem() {
  return {
    id: null,
    objetivo: '',
    departamento: null,
    dirigidoA: null,
    idplantel: null,
    responsablePlantel: null,
    fechaAuditoria: null,
    criterios: clonarCriteriosControlInterno(),
    salones: clonarSalonesControlInterno(),
    observacionesSalones: '',
    corte: crearDefaultCorteControlInterno(),
    vestimenta: crearDefaultVestimentaControlInterno(),
    riAtencionAlumno: crearDefaultRiAtencionAlumnoControlInterno(),
    metodologia5s: crearDefaultMetodologia5sControlInterno(),
    cierreAuditoria: crearDefaultCierreAuditoriaControlInterno()
  }
}

function clonarCriteriosControlInterno() {
  return CRITERIOS_CONTROL_INTERNO_BASE.map((item) => ({
    ...item,
    resultado: null
  }))
}

function clonarSalonesControlInterno() {
  return SALONES_CONTROL_INTERNO_BASE.map((item) => ({ ...item }))
}

function clonarCriteriosResultado(lista) {
  return lista.map((item) => ({ ...item }))
}

function crearDefaultCorteControlInterno() {
  return {
    encargada: '',
    recepcionTurno: '',
    criterios: clonarCriteriosResultado(CORTE_CONTROL_INTERNO_BASE),
    observaciones: ''
  }
}

function crearDefaultVestimentaControlInterno() {
  return {
    filas: VESTIMENTA_CONTROL_INTERNO_BASE.map((item) => ({ ...item })),
    observaciones: ''
  }
}

function crearDefaultRiAtencionAlumnoControlInterno() {
  return {
    encargada: '',
    encargadaCriterios: clonarCriteriosResultado(RI_ENCARGADA_CONTROL_INTERNO_BASE),
    encargadaObservaciones: '',
    recepcionCriterios: clonarCriteriosResultado(RI_RECEPCION_CONTROL_INTERNO_BASE),
    recepcionObservaciones: ''
  }
}

function crearDefaultMetodologia5sControlInterno() {
  return {
    criterios: clonarCriteriosResultado(METODOLOGIA_5S_CONTROL_INTERNO_BASE),
    nivelGeneral: null,
    climaGeneral: null,
    comunicacion: null,
    organizacionTurnos: null,
    liderazgo: null,
    operacion: null
  }
}

function crearFilasObservacionesControlInterno(cantidad) {
  return Array.from({ length: cantidad }, () => ({
    observacion: '',
    departamento: ''
  }))
}

function crearDefaultCierreAuditoriaControlInterno() {
  return {
    principalesHallazgos: crearFilasObservacionesControlInterno(2),
    areasOportunidad: crearFilasObservacionesControlInterno(2),
    fortalezasDetectadas: crearFilasObservacionesControlInterno(2),
    auditorFirma: '',
    responsablePlantelFirma: '',
    fechaFirma: null
  }
}

function clonarCriteriosBase() {
  return CRITERIOS_BASE.map((item) => ({
    id: item.id,
    idVisual: item.idVisual,
    id_criterio_catalogo: item.id,
    seccion: item.seccion,
    nombre: item.nombre,
    descripcion: item.descripcion,
    calificacion: null,
    evidencia: '',
    evidencia_hallazgo: ''
  }))
}

/** Texto de pregunta PHVA alineado a CRITERIOS_BASE (evita nombres viejos del catálogo API). */
function textoPreguntaCanonicaCriterio(criterio) {
  if (!criterio) return ''
  const vis = String(criterio.idVisual || '').trim()
  if (vis) {
    const porVisual = CRITERIOS_BASE.find((row) => row.idVisual === vis)
    if (porVisual && porVisual.nombre) return porVisual.nombre
  }
  const id = criterio.id != null ? Number(criterio.id) : null
  const idCat =
    criterio.id_criterio_catalogo != null ? Number(criterio.id_criterio_catalogo) : null
  const porId =
    (id != null && !Number.isNaN(id) && CRITERIOS_BASE.find((row) => row.id === id)) ||
    (idCat != null && !Number.isNaN(idCat) && CRITERIOS_BASE.find((row) => row.id === idCat))
  if (porId && porId.nombre) return porId.nombre
  return ''
}

export default {
  name: 'Auditoria',

  mixins: [validarErrores, funcionesExcel],

  components: {
    Alerta,
    carga
  },

  data() {
    return {
      parametros: {
        dialogError: false,
        mensaje: '',
        color: ''
      },
      respuestaAlerta: false,
      cargar: false,
      cargandoAuditorias: false,
      auditoriaTab: 0,
      dialog: false,
      dialogControlInterno: false,
      editedIndex: -1,
      editedControlInternoIndex: -1,
      acceso: true,
      fechaMaxima: new Date().toISOString().slice(0, 10),
      tiposAuditoria: TIPOS_AUDITORIA,
      auditorias: [],
      controlInternoAuditorias: [],
      reporteAuditorias: [],
      departamentos: [],
      planteles: [],
      usuariosCatalogo: [],
      /** true si respondió GET /catalogs/usuarios/auditoria (el backend puede mandar solo idusuario sin campo iderp). */
      usuariosCatalogoEsEndpointAuditoria: false,
      usuariosAll: [],
      usuariosAllErp: [],
      idsUsuariosInactivos: {},
      idsUsuariosPermitidosEnSelects: {},
      fotosEvidenciaPhva: {},
      evidenciasGeneralesPhva: {},
      fotosEvidenciaGeneralesPhva: {},
      criteriosPlantilla: [],
      criterios: clonarCriteriosBase(),
      filtros: {
        tipoAuditoria: null,
        fechaini: null,
        fechafin: null,
        colaborador: null,
        departamento: null,
        plantel: null,
        estatus: null,
        search: ''
      },
      editedItem: crearDefaultItem(),
      defaultItem: crearDefaultItem(),
      editedControlInternoItem: crearDefaultControlInternoItem(),
      defaultControlInternoItem: crearDefaultControlInternoItem(),
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Evalúa', value: 'auditor' },
        { text: 'Evaluado', value: 'departamento' },
        { text: 'Plantel', value: 'nombrePlantel' },
        { text: 'Promedio', value: 'resultadoPorcentaje', align: 'end' },
        { text: 'Concepto', value: 'tipoAuditoria', sortable: false },
        { text: 'Estatus', value: 'estatus', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
      ],
      headersControlInterno: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Objetivo', value: 'objetivo' },
        { text: 'Departamento', value: 'departamento' },
        { text: 'Dirigido a', value: 'dirigidoA' },
        { text: 'Plantel', value: 'nombrePlantel' },
        { text: 'Responsable del plantel', value: 'responsablePlantel' },
        { text: 'Fecha de auditoría', value: 'fechaAuditoria' },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    formTitle() {
      return this.editedIndex === -1 ? 'Nueva Auditoría' : 'Editar Auditoría'
    },

    controlInternoFormTitle() {
      return this.editedControlInternoIndex === -1 ? 'Nueva Auditoría de Control Interno' : 'Editar Auditoría de Control Interno'
    },

    resumenControlInternoModal() {
      let total = 0
      let completados = 0
      const contarResultado = (lista) => {
        ;(Array.isArray(lista) ? lista : []).forEach((item) => {
          total += 1
          if (item && item.resultado) completados += 1
        })
      }
      const contarBooleanos = (lista, campos) => {
        ;(Array.isArray(lista) ? lista : []).forEach((item) => {
          campos.forEach((campo) => {
            total += 1
            if (item && item[campo]) completados += 1
          })
        })
      }

      const item = this.editedControlInternoItem || {}
      contarResultado(item.criterios)
      contarBooleanos(item.salones, ['bancos', 'proyector', 'iluminacion', 'clima', 'pintura'])
      contarResultado(item.corte && item.corte.criterios)
      contarBooleanos(item.vestimenta && item.vestimenta.filas, [
        'uniformeCorrecto',
        'presentacionProfesional',
        'cumpleHorario',
        'permaneceArea'
      ])
      contarResultado(item.riAtencionAlumno && item.riAtencionAlumno.encargadaCriterios)
      contarResultado(item.riAtencionAlumno && item.riAtencionAlumno.recepcionCriterios)
      contarResultado(item.metodologia5s && item.metodologia5s.criterios)

      return { total, completados }
    },

    nivelGeneralControlInternoGrupos() {
      return [
        {
          campo: 'nivelGeneral',
          label: 'Nivel general del plantel',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.nivelGeneral
        },
        {
          campo: 'climaGeneral',
          label: 'Clima general',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.climaGeneral
        },
        {
          campo: 'comunicacion',
          label: 'Comunicación',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.comunicacion
        },
        {
          campo: 'organizacionTurnos',
          label: 'Organización de turnos',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.organizacionTurnos
        },
        {
          campo: 'liderazgo',
          label: 'Liderazgo',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.liderazgo
        },
        {
          campo: 'operacion',
          label: 'Operación (RI/corte/atención)',
          opciones: NIVEL_GENERAL_CONTROL_INTERNO_OPCIONES.operacion
        }
      ]
    },

    esTabEvaluacionPersonal() {
      return this.auditoriaTab === 0
    },

    tituloTablaActiva() {
      return this.esTabEvaluacionPersonal ? 'Evaluación Personal' : 'Control Interno'
    },

    auditoriasExportables() {
      return this.esTabEvaluacionPersonal ? this.auditoriasFiltradas : this.controlInternoFiltradas
    },

    nombreArchivoAuditorias() {
      return this.esTabEvaluacionPersonal ? 'auditorias_evaluacion_personal' : 'auditorias_control_interno'
    },

    tiposAuditoriaNombres() {
      return this.tiposAuditoria.map((item) => item.nombre)
    },

    tipoAuditoriaBackendMap() {
      return {
        Inicial: 'Inicial',
        Seguimiento: 'Seguimiento',
        'Auditoría 5S': 'Inicial',
        'Auditoría de Procesos': 'Seguimiento'
      }
    },

    estatusValidos() {
      return ESTATUS_VALIDOS
    },

    calificacionesValidas() {
      return CALIFICACIONES_VALIDAS
    },

    calificacionesPhvaSelect() {
      return [
        { text: '1 — No cumple', value: '1 - No cumple' },
        { text: '2 — Parcial', value: '2 - Parcial' },
        { text: '3 — Cumple totalmente', value: '3 - Cumple totalmente' },
        { text: 'N/A — No aplica', value: 'N/A' }
      ]
    },

    criteriosPhvaPorSeccion() {
      const orden = []
      const porTitulo = new Map()
      ;(this.criterios || []).forEach((c) => {
        const titulo = (c && c.seccion) || 'GENERAL'
        if (!porTitulo.has(titulo)) {
          porTitulo.set(titulo, [])
          orden.push(titulo)
        }
        porTitulo.get(titulo).push(c)
      })
      return orden.map((titulo) => ({ titulo, items: porTitulo.get(titulo) || [] }))
    },

    criteriosPhvaFilasTabla() {
      const filas = []
      this.criteriosPhvaPorSeccion.forEach((grupo, gIdx) => {
        filas.push({ kind: 'header', titulo: grupo.titulo, _key: `phva-h-${gIdx}` })
        ;(grupo.items || []).forEach((c, cIdx) => {
          filas.push({
            kind: 'row',
            c,
            _key: `phva-r-${gIdx}-${c.id != null ? c.id : cIdx}`
          })
        })
        // Agregar fila de evidencia general al final de cada sección
        filas.push({
          kind: 'evidencia-general',
          seccion: grupo.titulo,
          _key: `phva-eg-${gIdx}`
        })
      })
      return filas
    },

    conteosDepartamentoDesdeListadoAuditorias() {
      const mapa = new Map()

      const upsert = (llave, nombre) => {
        if (!mapa.has(llave)) {
          mapa.set(llave, {
            id_departamento: null,
            departamento: nombre || '',
            conteoInicial: 0,
            conteoSeguimiento: 0,
            resultados: []
          })
        }
        return mapa.get(llave)
      }

      const lista = this.auditoriasFiltradas || []

      lista.forEach((item) => {
        const idDept = item.id_departamento != null ? item.id_departamento : null
        const nombreDept = item.departamento || item.nombre_departamento || ''
        const llave = idDept != null && idDept !== '' ? `id:${String(idDept)}` : `nom:${this.normalizarTexto(nombreDept)}`

        const row = upsert(llave, nombreDept)
        if (row.id_departamento == null && idDept != null && idDept !== '') {
          row.id_departamento = idDept
        }
        if (!row.departamento && nombreDept) {
          row.departamento = nombreDept
        }

        const estatus = String(item.estatus || '').trim()
        const tipoVisible = this.tipoAuditoriaVisible(item.tipoAuditoria)

        let bucket = null
        if (estatus === 'Inicial' || estatus === 'Seguimiento') {
          bucket = estatus
        } else if (tipoVisible === 'Inicial' || tipoVisible === 'Seguimiento') {
          bucket = tipoVisible
        }

        if (bucket === 'Inicial') row.conteoInicial += 1
        if (bucket === 'Seguimiento') row.conteoSeguimiento += 1

        const r = item.resultadoPorcentaje
        if (r != null && r !== '' && !Number.isNaN(Number(r))) {
          row.resultados.push(Number(r))
        }
      })

      return mapa
    },

    tarjetasReporteDepartamento() {
      const mapa = this.conteosDepartamentoDesdeListadoAuditorias

      const baseRows = Array.isArray(this.reporteAuditorias) ? this.reporteAuditorias : []

      const construirTarjeta = (meta, agg) => {
        const conteoInicial = agg ? agg.conteoInicial : 0
        const conteoSeguimiento = agg ? agg.conteoSeguimiento : 0
        const res = agg && agg.resultados && agg.resultados.length ? agg.resultados : []
        const promedioResultado = res.length ? res.reduce((a, b) => a + b, 0) / res.length : 0

        return {
          id_departamento:
            meta.id_departamento != null
              ? meta.id_departamento
              : meta.id != null
                ? meta.id
                : null,
          departamento: meta.departamento || '',
          conteoInicial,
          conteoSeguimiento,
          promedioResultado
        }
      }

      if (baseRows.length) {
        return baseRows
          .map((item) => {
            const idDept = item.id_departamento != null ? item.id_departamento : item.id != null ? item.id : null
            const nombreDept = item.nombre_departamento || item.departamento || ''
            const llave = idDept != null && idDept !== '' ? `id:${String(idDept)}` : `nom:${this.normalizarTexto(nombreDept)}`
            const agg = mapa.get(llave) || null

            return construirTarjeta(
              {
                id_departamento: idDept,
                departamento: nombreDept
              },
              agg
            )
          })
          .sort((a, b) =>
            String(a.departamento || '').localeCompare(String(b.departamento || ''), 'es', { sensitivity: 'base' })
          )
      }

      return Array.from(mapa.values())
        .map((agg) =>
          construirTarjeta(
            {
              id_departamento: agg.id_departamento,
              departamento: agg.departamento
            },
            agg
          )
        )
        .filter((t) => t.departamento || t.id_departamento != null)
        .sort((a, b) =>
          String(a.departamento || '').localeCompare(String(b.departamento || ''), 'es', { sensitivity: 'base' })
        )
    },

    totalesReporteTarjetas() {
      const filas = this.tarjetasReporteDepartamento
      if (!filas.length) {
        return {
          conteoInicial: 0,
          conteoSeguimiento: 0,
          promedioResultado: 0
        }
      }

      const sumas = filas.reduce(
        (acc, item) => {
          acc.conteoInicial += Number(item.conteoInicial || 0)
          acc.conteoSeguimiento += Number(item.conteoSeguimiento || 0)
          acc.promedio += Number(item.promedioResultado || 0)
          return acc
        },
        { conteoInicial: 0, conteoSeguimiento: 0, promedio: 0 }
      )

      return {
        conteoInicial: sumas.conteoInicial,
        conteoSeguimiento: sumas.conteoSeguimiento,
        promedioResultado: filas.length ? sumas.promedio / filas.length : 0
      }
    },

    tarjetasReporteControlInterno() {
      const mapa = new Map()
      ;(this.controlInternoFiltradas || []).forEach((item) => {
        const idDept = item.id_departamento != null ? item.id_departamento : item.departamentoId
        const nombreDept = item.departamento || item.nombre_departamento || 'Sin departamento'
        const llave = idDept != null && idDept !== '' ? `id:${String(idDept)}` : `nom:${this.normalizarTexto(nombreDept)}`

        if (!mapa.has(llave)) {
          mapa.set(llave, {
            id_departamento: idDept != null ? idDept : null,
            departamento: nombreDept,
            totalAuditorias: 0,
            planteles: new Set(),
            responsables: new Set()
          })
        }

        const row = mapa.get(llave)
        row.totalAuditorias += 1
        if (item.id_plantel != null && item.id_plantel !== '') {
          row.planteles.add(String(item.id_plantel))
        }
        if (item.id_responsable_plantel != null && item.id_responsable_plantel !== '') {
          row.responsables.add(String(item.id_responsable_plantel))
        }
      })

      return Array.from(mapa.values())
        .map((item) => ({
          id_departamento: item.id_departamento,
          departamento: item.departamento,
          totalAuditorias: item.totalAuditorias,
          totalPlanteles: item.planteles.size,
          totalResponsables: item.responsables.size
        }))
        .sort((a, b) =>
          String(a.departamento || '').localeCompare(String(b.departamento || ''), 'es', { sensitivity: 'base' })
        )
    },

    totalesReporteControlInterno() {
      const planteles = new Set()
      const responsables = new Set()
      ;(this.controlInternoFiltradas || []).forEach((item) => {
        if (item.id_plantel != null && item.id_plantel !== '') {
          planteles.add(String(item.id_plantel))
        }
        if (item.id_responsable_plantel != null && item.id_responsable_plantel !== '') {
          responsables.add(String(item.id_responsable_plantel))
        }
      })

      return {
        totalAuditorias: (this.controlInternoFiltradas || []).length,
        totalPlanteles: planteles.size,
        totalResponsables: responsables.size
      }
    },

    usuariosSelects() {
      const referencias = []
      this.auditorias.forEach((item) => this.agregarReferenciasUsuarioDesdeAuditoria(referencias, item))

      const fusionados = this.fusionarListaUsuariosParaSelects(
        [...this.usuariosCatalogo, ...this.usuariosAllErp, ...this.usuariosAll],
        referencias
      )

      const lista = this.disambiguarEtiquetasUsuariosDuplicados(this.dedupeUsuariosPorId(fusionados))
      return this.filtrarUsuariosActivosParaSelect(lista)
    },

    usuariosSoloCatalogoErp() {
      const iderpExplicitoEnFila = (u) => {
        if (!u) return null
        const raw = u.iderp != null && u.iderp !== '' ? u.iderp : u.IDERP != null && u.IDERP !== '' ? u.IDERP : null
        if (raw == null || raw === '') return null
        const n = Number(raw)
        return !Number.isNaN(n) && n > 0 ? n : null
      }

      const idusuarioCatalogoNumerico = (u) => {
        if (!u || u.idusuario == null || u.idusuario === '') return null
        const n = Number(u.idusuario)
        return !Number.isNaN(n) && n > 0 ? n : null
      }

      const elegibleResponsable = (u) => {
        if (iderpExplicitoEnFila(u) != null) return true
        if (this.usuariosCatalogoEsEndpointAuditoria && idusuarioCatalogoNumerico(u) != null) return true
        return false
      }

      // iderp explícito, o catálogo /auditoria con idusuario = FK ERP (sin duplicar filas mezcladas desde usuarios.all).
      const soloCatalogoFk = (this.usuariosCatalogo || []).filter(elegibleResponsable)

      const base = soloCatalogoFk.map((u) => this.normalizarUsuario(u))
      const dedup = this.dedupeUsuariosPorId(base)

      const filasNombre = [...(this.usuariosAllErp || []), ...(this.usuariosAll || []), ...(this.auditorias || [])]

      // Solo IDs del catálogo ERP; pero mejora la etiqueta con nombres encontrados en otras listas.
      const conEtiquetas = this.combinarEtiquetasUsuarios(dedup, filasNombre)
      const disamb = this.disambiguarEtiquetasUsuariosDuplicados(conEtiquetas)
      return this.filtrarUsuariosActivosParaSelect(disamb).sort((a, b) =>
        String(this.etiquetaUsuarioSelect(a) || '').localeCompare(String(this.etiquetaUsuarioSelect(b) || ''), 'es', {
          sensitivity: 'base'
        })
      )
    },

    colaboradores() {
      return this.usuariosSelects
    },

    mapaNombreUsuarioPorId() {
      const mapa = this.construirMapaNombrePorCualquierId([
        ...this.usuariosCatalogo,
        ...this.usuariosAll,
        ...this.usuariosAllErp,
        ...this.usuariosSelects,
        ...this.auditorias
      ])
      const salida = {}
      mapa.forEach((valor, llave) => {
        salida[llave] = valor
      })
      return salida
    },

    mapaNombrePlantelPorId() {
      return this.planteles.reduce((acc, item) => {
        if (item.idplantel != null && item.idplantel !== '') {
          acc[String(item.idplantel)] = item.plantel || item.nombre || ''
        }
        return acc
      }, {})
    },

    auditoriasEnriquecidas() {
      return this.auditorias.map((item) => {
        const idRegistro =
          item.usuario_registro ||
          item.id_usuario_creacion ||
          item.id_usuario_actualizacion ||
          item.id_auditor

        const nombreRegistro =
          this.obtenerNombreUsuario(
            idRegistro,
            item.nombre_usuario_registro ||
              item.nombre_usuario_creacion ||
              item.usuario_registro_nombre ||
              item.nombre_auditor
          ) || ''

        const auditor = this.obtenerNombreUsuario(item.id_auditor, item.nombre_auditor || item.auditor)
        const jefe = this.obtenerNombreUsuario(
          item.id_jefe_departamento,
          item.nombre_jefe || item.nombre_jefe_departamento
        )
        const responsable = this.obtenerNombreUsuario(item.id_responsable, item.nombre_responsable)
        const plantel = this.nombrePlantel(item.id_plantel || item.idplantel, item.nombre_plantel)
        const resultado =
          item.resultado_porcentaje != null && item.resultado_porcentaje !== ''
            ? Number(item.resultado_porcentaje)
            : this.calcularResultadoPorcentaje(item.criterios || [])

        return {
          ...item,
          id: item.id,
          departamento: item.nombre_departamento || item.departamento || '',
          tipoAuditoria: item.tipo_auditoria || item.tipoAuditoria || '',
          auditor,
          jefeDepartamento: jefe,
          responsable,
          nombrePlantel: plantel,
          fecha: this.formatearFechaInput(item.fecha_auditoria || item.fecha),
          resultadoPorcentaje: resultado,
          usuario_registro: idRegistro,
          usuario_registro_nombre: nombreRegistro,
          idusuario: idRegistro
        }
      })
    },

    auditoriasFiltradas() {
      let lista = this.auditoriasEnriquecidas
        .filter((item) => this.filaAuditoriaSoloUsuariosActivosSn(item))
        .slice()
      const filtros = this.filtros
      const textoBuscar = this.normalizarTexto(filtros.search)

      if (filtros.tipoAuditoria) {
        lista = lista.filter((item) => item.tipoAuditoria === filtros.tipoAuditoria)
      }

      if (filtros.estatus != null && filtros.estatus !== '') {
        lista = lista.filter((item) => item.estatus === filtros.estatus)
      }

      if (filtros.departamento != null && filtros.departamento !== '') {
        lista = lista.filter((item) => String(item.id_departamento || '') === String(filtros.departamento))
      }

      if (filtros.plantel != null && filtros.plantel !== '') {
        lista = lista.filter((item) => String(item.id_plantel || item.idplantel || '') === String(filtros.plantel))
      }

      if (filtros.colaborador != null && filtros.colaborador !== '') {
        const colaboradorId = String(filtros.colaborador)
        lista = lista.filter((item) => {
          const ids = [
            item.usuario_registro,
            item.idusuario,
            item.id_auditor,
            item.id_usuario_creacion,
            item.id_usuario_actualizacion
          ]
            .filter((valor) => valor != null && valor !== '')
            .map((valor) => String(valor))

          return ids.includes(colaboradorId)
        })
      }

      if (filtros.fechaini) {
        lista = lista.filter((item) => !item.fecha || item.fecha >= filtros.fechaini)
      }

      if (filtros.fechafin) {
        lista = lista.filter((item) => !item.fecha || item.fecha <= filtros.fechafin)
      }

      if (textoBuscar) {
        lista = lista.filter((item) => this.textoBusquedaAuditoria(item).includes(textoBuscar))
      }

      return lista
    },

    controlInternoEnriquecidas() {
      return this.controlInternoAuditorias.map((item) => {
        const idDept =
          item.id_departamento != null
            ? item.id_departamento
            : item.departamento != null
              ? item.departamento
              : null
        const idPlantel =
          item.id_plantel != null
            ? item.id_plantel
            : item.idplantel != null
              ? item.idplantel
              : null
        const idDirigido =
          item.id_dirigido_a != null
            ? item.id_dirigido_a
            : item.dirigidoA != null
              ? item.dirigidoA
              : null
        const idResponsable =
          item.id_responsable_plantel != null
            ? item.id_responsable_plantel
            : item.responsablePlantel != null
              ? item.responsablePlantel
              : null

        return {
          ...item,
          id: item.id,
          id_departamento: idDept,
          id_plantel: idPlantel,
          id_dirigido_a: idDirigido,
          id_responsable_plantel: idResponsable,
          objetivo: item.objetivo || '',
          departamento: this.nombreDepartamento(idDept, item.nombre_departamento || item.departamentoNombre),
          dirigidoA: this.obtenerNombreUsuario(idDirigido, item.nombre_dirigido_a || item.dirigido_a),
          nombrePlantel: this.nombrePlantel(idPlantel, item.nombre_plantel || item.plantel),
          responsablePlantel: this.obtenerNombreUsuario(
            idResponsable,
            item.nombre_responsable_plantel || item.responsable_plantel
          ),
          fechaAuditoria: this.formatearFechaInput(item.fecha_auditoria || item.fechaAuditoria)
        }
      })
    },

    controlInternoFiltradas() {
      let lista = this.controlInternoEnriquecidas.slice()
      const filtros = this.filtros
      const textoBuscar = this.normalizarTexto(filtros.search)

      if (filtros.departamento != null && filtros.departamento !== '') {
        lista = lista.filter((item) => String(item.id_departamento || '') === String(filtros.departamento))
      }

      if (filtros.plantel != null && filtros.plantel !== '') {
        lista = lista.filter((item) => String(item.id_plantel || '') === String(filtros.plantel))
      }

      if (filtros.colaborador != null && filtros.colaborador !== '') {
        const colaboradorId = String(filtros.colaborador)
        lista = lista.filter((item) =>
          [item.id_dirigido_a, item.id_responsable_plantel]
            .filter((valor) => valor != null && valor !== '')
            .map((valor) => String(valor))
            .includes(colaboradorId)
        )
      }

      if (filtros.fechaini) {
        lista = lista.filter((item) => !item.fechaAuditoria || item.fechaAuditoria >= filtros.fechaini)
      }

      if (filtros.fechafin) {
        lista = lista.filter((item) => !item.fechaAuditoria || item.fechaAuditoria <= filtros.fechafin)
      }

      if (textoBuscar) {
        lista = lista.filter((item) => this.textoBusquedaControlInterno(item).includes(textoBuscar))
      }

      return lista
    }
  },

  methods: {
    criteriosVacios() {
      return clonarCriteriosBase()
    },

    etiquetaPreguntaPhva(criterio) {
      const canon = textoPreguntaCanonicaCriterio(criterio)
      if (canon) return canon
      return String(criterio && criterio.nombre ? criterio.nombre : '').trim()
    },

    tipoAuditoriaVisible(valor) {
      const texto = String(valor || '').trim()
      if (texto === 'Auditoría 5S') return 'Inicial'
      if (texto === 'Auditoría de Procesos') return 'Seguimiento'
      if (this.tiposAuditoriaNombres.includes(texto)) return texto
      return texto
    },

    tipoAuditoriaParaBackend(valor) {
      const texto = String(valor || '').trim()
      return this.tipoAuditoriaBackendMap[texto] || texto
    },

    claveCriterioPhva(criterio) {
      return String((criterio && (criterio.idVisual || criterio.id || criterio.id_criterio_catalogo)) || '')
    },

    esCriterioFotoComentario(criterio) {
      return this.claveCriterioPhva(criterio) === '1.2'
    },

    placeholderEvidenciaPhva(criterio) {
      return this.esCriterioFotoComentario(criterio) ? 'Foto/comentario' : 'Evidencia / Hallazgo'
    },

    obtenerFotoEvidencia(criterio) {
      const clave = this.claveCriterioPhva(criterio)
      return this.fotosEvidenciaPhva[clave] || ''
    },

    separarEvidenciaYFoto(valor) {
      const texto = String(valor || '')
      const idx = texto.indexOf(EVIDENCIA_FOTO_MARKER)
      if (idx === -1) {
        return { comentario: texto, fotoBase64: '' }
      }

      return {
        comentario: texto.slice(0, idx).trim(),
        fotoBase64: texto.slice(idx + EVIDENCIA_FOTO_MARKER.length).trim()
      }
    },

    construirEvidenciaConFoto(comentario, fotoBase64) {
      const texto = String(comentario || '').trim()
      if (!fotoBase64) return texto
      return `${texto}\n${EVIDENCIA_FOTO_MARKER}${fotoBase64}`.trim()
    },

    onFotoEvidenciaChange(criterio, file) {
      const clave = this.claveCriterioPhva(criterio)
      if (!clave) return

      const archivo = Array.isArray(file) ? file[0] : file
      if (!archivo) {
        this.$delete(this.fotosEvidenciaPhva, clave)
        return
      }

      const reader = new FileReader()
      reader.onload = () => {
        this.$set(this.fotosEvidenciaPhva, clave, String(reader.result || ''))
      }
      reader.readAsDataURL(archivo)
    },

    quitarFotoEvidencia(criterio) {
      const clave = this.claveCriterioPhva(criterio)
      if (!clave) return
      this.$delete(this.fotosEvidenciaPhva, clave)
    },

    onFotoEvidenciaGeneralChange(seccion, file) {
      if (!seccion) return
      const archivo = Array.isArray(file) ? file[0] : file
      if (!archivo) {
        this.$delete(this.fotosEvidenciaGeneralesPhva, seccion)
        return
      }
      const reader = new FileReader()
      reader.onload = () => {
        this.$set(this.fotosEvidenciaGeneralesPhva, seccion, reader.result)
      }
      reader.readAsDataURL(archivo)
    },

    obtenerFotoEvidenciaGeneral(seccion) {
      if (!seccion) return ''
      return this.fotosEvidenciaGeneralesPhva[seccion] || ''
    },

    quitarFotoEvidenciaGeneral(seccion) {
      if (!seccion) return
      this.$delete(this.fotosEvidenciaGeneralesPhva, seccion)
    },

    extraerArray(response) {
      const body = response && response.data !== undefined ? response.data : response

      if (Array.isArray(body)) return body
      if (body && Array.isArray(body.data)) return body.data
      return []
    },

    extraerObjeto(response) {
      const body = response && response.data !== undefined ? response.data : response
      if (body && body.data !== undefined && !Array.isArray(body.data)) return body.data
      return body
    },

    normalizarTexto(valor) {
      return String(valor || '')
        .trim()
        .toLowerCase()
    },

    formatearFechaInput(valor) {
      if (!valor) return null
      return String(valor).slice(0, 10)
    },

    normalizarValorSelectNumerico(valor) {
      if (valor == null || valor === '') return ''
      if (typeof valor === 'number') return valor
      const texto = String(valor).trim()
      if (/^\d+$/.test(texto)) {
        const numero = Number(texto)
        return Number.isNaN(numero) ? texto : numero
      }
      return texto
    },

    /** Valor de v-select / FK ERP: prioriza iderp del catálogo cuando existe. */
    idParaSelectUsuario(u) {
      if (!u) return null
      if (u.iderp != null && u.iderp !== '') return u.iderp
      if (u.idusuario != null && u.idusuario !== '') return u.idusuario
      if (u.id_usuario != null && u.id_usuario !== '') return u.id_usuario
      if (u.id != null && u.id !== '') return u.id
      return null
    },

    obtenerIdSesion() {
      if (!this.getdatosUsuarioERPERP) return null
      const u = this.getdatosUsuarioERPERP
      if (u.idusuario != null && u.idusuario !== '') return u.idusuario
      if (u.id_usuario != null && u.id_usuario !== '') return u.id_usuario
      if (u.iderp != null && u.iderp !== '') return u.iderp
      return null
    },

    /**
     * Solo el select Responsable usa item-value iderp; auditor/jefe/colaborador usan idusuario.
     * @param {boolean} usarIderpFk - true solo para id_responsable
     */
    resolverIdUsuarioFkParaPayload(valorSeleccionado, usarIderpFk = false) {
      if (valorSeleccionado == null || valorSeleccionado === '') return null

      if (typeof valorSeleccionado === 'object') {
        const obj = valorSeleccionado || {}
        if (usarIderpFk) {
          const idDirecto =
            obj.iderp != null && obj.iderp !== ''
              ? obj.iderp
              : obj.idusuario != null && obj.idusuario !== ''
                ? obj.idusuario
                : obj.id_usuario != null && obj.id_usuario !== ''
                  ? obj.id_usuario
                  : obj.id != null && obj.id !== ''
                    ? obj.id
                    : null
          return idDirecto != null && idDirecto !== '' ? idDirecto : null
        }
        const idDirecto =
          obj.idusuario != null && obj.idusuario !== ''
            ? obj.idusuario
            : obj.id_usuario != null && obj.id_usuario !== ''
              ? obj.id_usuario
              : obj.id != null && obj.id !== ''
                ? obj.id
                : obj.iderp != null && obj.iderp !== ''
                  ? obj.iderp
                  : null
        return idDirecto != null && idDirecto !== '' ? idDirecto : null
      }

      const k = String(valorSeleccionado).trim()
      if (!k) return null

      const candidatosLista = [...(this.usuariosSelects || [])]

      const matchEnLista = candidatosLista.find((u) => {
        if (!u) return false
        const ids = [u.iderp, u.idusuario, u.id_usuario, u.id].filter((v) => v != null && v !== '')
        return ids.some((v) => String(v) === k)
      })

      if (matchEnLista) {
        if (usarIderpFk) {
          const idSel = this.idParaSelectUsuario(matchEnLista)
          if (idSel != null && idSel !== '') return idSel
        } else {
          if (matchEnLista.idusuario != null && matchEnLista.idusuario !== '') return matchEnLista.idusuario
          if (matchEnLista.id_usuario != null && matchEnLista.id_usuario !== '') return matchEnLista.id_usuario
          if (matchEnLista.id != null && matchEnLista.id !== '') return matchEnLista.id
          return matchEnLista.iderp != null && matchEnLista.iderp !== '' ? matchEnLista.iderp : null
        }
      }

      const fuentes = [...this.usuariosCatalogo, ...this.usuariosAllErp, ...this.usuariosAll]
      for (let i = 0; i < fuentes.length; i++) {
        const row = fuentes[i]
        const n = this.normalizarUsuario(row)
        const ids = [n.iderp, n.idusuario, n.id_usuario, row.id].filter((v) => v != null && v !== '')
        if (!ids.some((v) => String(v) === k)) continue
        if (usarIderpFk) {
          const idOut = this.idParaSelectUsuario(n)
          if (idOut != null && idOut !== '') return idOut
        } else {
          if (n.idusuario != null && n.idusuario !== '') return n.idusuario
          if (n.id_usuario != null && n.id_usuario !== '') return n.id_usuario
          if (row.id != null && String(row.id) === k) return row.id
          return n.iderp != null && n.iderp !== '' ? n.iderp : null
        }
      }

      if (/^\d+$/.test(k)) {
        const n = Number(k)
        return Number.isNaN(n) ? null : n
      }

      return null
    },

    /** Mapea idusuario del auditor al iderp del select Responsable (solo si hay fila con iderp real en el catálogo). */
    idResponsableSelectDesdeIdUsuarioOAuditor(valor) {
      if (valor == null || valor === '') return null
      const k = String(valor)
      const candidatos = this.usuariosSoloCatalogoErp || []
      const match = candidatos.find((u) => {
        if (!u) return false
        return [u.idusuario, u.id_usuario, u.iderp].some((v) => v != null && String(v) === k)
      })
      if (!match) return null
      const idErp = this.idParaSelectUsuario(match)
      return idErp != null && idErp !== '' ? idErp : null
    },

    asegurarUsuarioEnCatalogoLocal(idUsuario, etiquetaFallback) {
      if (idUsuario == null || idUsuario === '') return
      const k = String(idUsuario)
      const num = Number.isNaN(Number(k)) ? idUsuario : Number(k)
      const existe = (this.usuariosCatalogo || []).some((u) => {
        const n = this.normalizarUsuario(u)
        return [n.iderp, n.idusuario, n.id_usuario].some((v) => v != null && String(v) === k)
      })
      if (existe) return

      const texto = String(etiquetaFallback || this.obtenerNombreUsuario(idUsuario, '') || '').trim()
      if (!texto || this.etiquetaUsuarioGenerica(texto)) return

      this.usuariosCatalogo.push(
        this.normalizarUsuario({
          iderp: num,
          idusuario: num,
          usuario_registro: texto
        })
      )
    },

    etiquetaUsuarioGenerica(texto) {
      if (texto == null || texto === '') return true
      const s = String(texto).trim()
      if (/^Usuario\s+\d+$/i.test(s)) return true
      if (/^\d+$/.test(s)) return true
      return false
    },

    textoNombreHumano(valor) {
      if (valor == null || valor === '') return ''
      if (typeof valor !== 'string') return ''
      const s = valor.trim()
      if (!s || /^\d+$/.test(s)) return ''
      return s
    },

    etiquetaUsuarioSelect(item) {
      const u = item || {}
      const candidatas = [
        this.textoNombreHumano(u.label),
        this.textoNombreHumano(u.nombre_mostrar),
        this.textoNombreHumano(u.nombre_display),
        this.textoNombreHumano(u.texto_select),
        this.textoNombreHumano(u.usuario_registro),
        this.textoNombreHumano(u.nombre_completo),
        this.textoNombreHumano(u.nombreCompleto),
        this.textoNombreHumano(u.nombre),
        [u.nombre, u.apellido].filter(Boolean).join(' ').trim(),
        [u.nombre_usuario, u.apellido_usuario].filter(Boolean).join(' ').trim(),
        this.nombreDesdeDatosCompletos(u),
        typeof u.usuario === 'string' ? this.textoNombreHumano(u.usuario) : '',
        this.textoNombreHumano(u.email)
      ]

      const nombre = candidatas
        .map((t) => String(t || '').trim())
        .find((t) => t && !/^\d+$/.test(t))
      if (nombre) return nombre

      return ''
    },

    nombreDesdeDatosCompletos(item) {
      const dc = item && item.datos_completos
      if (dc == null || typeof dc !== 'string') return null
      const primera = dc
        .split('/')
        .map((s) => s.trim())
        .find((s) => s.length)
      return this.esTextoNombreUsuarioValido(primera) ? primera : null
    },

    activoSnExplicitamenteInactivo(v) {
      if (v == null || v === '') return false
      const texto = String(v).trim().toLowerCase()
      if (['1', 'true', 'activo', 'activa', 'a', 'si', 'sí'].includes(texto)) return false
      if (['0', 'false', 'inactivo', 'inactiva', 'baja', 'deleted', 'eliminado'].includes(texto)) return true
      return false
    },

    valorEliminadoExplicitamente(v) {
      if (v == null || v === '') return false
      const texto = String(v).trim().toLowerCase()
      return ['1', 'true', 'si', 'sí', 'deleted', 'eliminado'].includes(texto)
    },

    obtenerActivoSnTrabajadorDesdeFila(row) {
      if (!row) return null
      const candidatos = [
        row.trabajador_activo_sn,
        row.activo_sn_trabajador,
        row.activo_trabajador_sn,
        row.t_activo_sn,
        row.trabajador_activo,
        row.activo_trabajador,
        row.cat_trabajador_activo_sn,
        row && row.trabajador && row.trabajador.activo_sn
      ]
      for (let i = 0; i < candidatos.length; i++) {
        const v = candidatos[i]
        if (v == null || v === '') continue
        if (Number(v) === 1 || v === true || v === '1') return true
        return false
      }
      return null
    },

    filaUsuarioActivoParaSelect(row) {
      if (row == null) return false
      const eliminados = [row.deleted, row.DELETED, row.eliminado, row.eliminado_sn, row.borrado_sn]
      if (eliminados.some((v) => this.valorEliminadoExplicitamente(v))) return false
      const activos = [row.activo_sn, row.ACTIVO_SN, row.activo, row.ACTIVO, row.estatus, row.status]
      if (activos.some((v) => this.activoSnExplicitamenteInactivo(v))) return false
      const t = this.obtenerActivoSnTrabajadorDesdeFila(row)
      if (t === false) return false
      return true
    },

    obtenerMapaIdsUsuariosInactivos(listas) {
      const map = {}
      ;(listas || []).forEach((arr) => {
        ;(Array.isArray(arr) ? arr : []).forEach((row) => {
          if (this.filaUsuarioActivoParaSelect(row)) return
          const ids = [row.id_usuario, row.idusuario, row.iderp, row.id].filter((v) => v != null && v !== '')
          ids.forEach((id) => {
            map[String(id)] = true
          })
        })
      })
      return map
    },

    esIdUsuarioInactivoEnCatalogos(id) {
      if (id == null || id === '') return false
      return !!this.idsUsuariosInactivos[String(id)]
    },

    recopilarIdsUsuariosPermitidosDesdeCatalogosCargados(listas) {
      const map = {}
      ;(listas || []).forEach((arr) => {
        ;(Array.isArray(arr) ? arr : []).forEach((row) => {
          const n = this.normalizarUsuario(row)
          ;[n.iderp, n.idusuario, n.id_usuario]
            .filter((v) => v != null && v !== '')
            .forEach((v) => {
              map[String(v)] = true
            })
        })
      })
      return map
    },

    filtrarUsuariosActivosParaSelect(lista) {
      const permitir = this.idsUsuariosPermitidosEnSelects
      const usarListaBlanca = permitir && Object.keys(permitir).length > 0

      return (Array.isArray(lista) ? lista : []).filter((u) => {
        if (!u) return false
        const idSel = this.idParaSelectUsuario(u)
        if (idSel == null || idSel === '') return false
        if (!String(this.etiquetaUsuarioSelect(u) || '').trim()) return false
        if (this.esIdUsuarioInactivoEnCatalogos(idSel)) return false
        if (usarListaBlanca && !permitir[String(idSel)]) return false
        return true
      })
    },

    idsUsuariosReferenciadosEnAuditoria(item) {
      const raw = [
        item && item.id_auditor,
        item && item.id_jefe_departamento,
        item && item.id_responsable,
        item && item.id_usuario_creacion,
        item && item.id_usuario_actualizacion
      ]
      const set = new Set()
      raw.forEach((v) => {
        if (v != null && v !== '') set.add(String(v))
      })
      return Array.from(set)
    },

    usuarioCumpleActivoSnParaVista(itemIdUsuario) {
      if (itemIdUsuario == null || itemIdUsuario === '') return true
      const id = String(itemIdUsuario)
      if (this.esIdUsuarioInactivoEnCatalogos(id)) return false
      const permitir = this.idsUsuariosPermitidosEnSelects
      const usarListaBlanca = permitir && Object.keys(permitir).length > 0
      if (usarListaBlanca && !permitir[id]) return false
      return true
    },

    filaAuditoriaSoloUsuariosActivosSn(item) {
      const ids = this.idsUsuariosReferenciadosEnAuditoria(item)
      if (!ids.length) return true
      return ids.every((id) => this.usuarioCumpleActivoSnParaVista(id))
    },

    esTextoNombreUsuarioValido(valor) {
      if (valor == null || valor === '') return false
      const s = String(valor).trim()
      if (!s) return false
      if (/^\d+$/.test(s)) return false
      return true
    },

    agregarReferenciasUsuarioDesdeAuditoria(referencias, item) {
      if (!item) return
      const idsCatalogo = new Set()
      ;(this.usuariosCatalogo || []).forEach((u) => {
        if (!u) return
        const n = this.normalizarUsuario(u)
        ;[n.iderp, n.idusuario, n.id_usuario]
          .filter((v) => v != null && v !== '')
          .forEach((v) => idsCatalogo.add(String(v)))
      })

      const agregarSiEnCatalogoErp = (idUsuario) => {
        if (idUsuario == null || idUsuario === '') return
        const k = String(idUsuario)
        if (!idsCatalogo.has(k)) return
        referencias.push({
          idusuario: idUsuario,
          iderp: idUsuario,
          usuario_registro: ''
        })
      }

      agregarSiEnCatalogoErp(item.id_auditor)
      agregarSiEnCatalogoErp(item.id_jefe_departamento)
      agregarSiEnCatalogoErp(item.id_responsable)

      const idRegistro =
        item.usuario_registro || item.id_usuario_creacion || item.id_usuario_actualizacion || item.id_auditor
      agregarSiEnCatalogoErp(idRegistro)
    },

    esEtiquetaMasLegible(candidata, actual) {
      const cand = String(candidata || '').trim()
      const act = String(actual || '').trim()

      if (!cand) return false
      if (!act) return true
      if (this.etiquetaUsuarioGenerica(act) && !this.etiquetaUsuarioGenerica(cand)) return true
      if (act.length < 5 && cand.length >= 5) return true
      return cand.length > act.length && !this.etiquetaUsuarioGenerica(cand)
    },

    normalizarUsuario(raw) {
      const item = raw || {}
      const nombreArmado = [item.nombre, item.apellido].filter(Boolean).join(' ').trim()
      const nombreUsuarioArmado = [item.nombre_usuario, item.apellido_usuario]
        .filter(Boolean)
        .join(' ')
        .trim()

      const candidatas = [
        item.label,
        item.nombre_mostrar,
        item.nombre_display,
        item.texto_select,
        item.nombre_completo,
        item.nombreCompleto,
        item.nombre,
        nombreArmado,
        nombreUsuarioArmado,
        typeof item.usuario === 'string' ? item.usuario : null,
        item.usuario_registro,
        item.nombre_usuario,
        this.nombreDesdeDatosCompletos(item),
        item.email
      ]

      let idusuario =
        item.idusuario != null && item.idusuario !== ''
          ? item.idusuario
          : item.id_usuario != null && item.id_usuario !== ''
            ? item.id_usuario
            : item.id != null && item.id !== ''
              ? item.id
              : null

      if (
        idusuario == null &&
        item.usuario_registro != null &&
        item.usuario_registro !== '' &&
        !Number.isNaN(Number(item.usuario_registro))
      ) {
        idusuario = item.usuario_registro
      }

      const iderpBruto = item.iderp != null && item.iderp !== '' ? item.iderp : item.IDERP != null && item.IDERP !== '' ? item.IDERP : null

      if ((idusuario == null || idusuario === '') && iderpBruto != null) {
        idusuario = iderpBruto
      }

      const etiqueta = candidatas.find((valor) => this.esTextoNombreUsuarioValido(valor))

      return {
        ...item,
        idusuario,
        id_usuario: item.id_usuario != null ? item.id_usuario : idusuario,
        iderp: iderpBruto != null ? iderpBruto : item.id_usuario != null ? item.id_usuario : idusuario,
        usuario_registro: String(etiqueta || '').trim(),
        nombre_completo: String(etiqueta || '').trim(),
        datos_completos: String(item.datos_completos || etiqueta || '').trim(),
        puesto: item.puesto || item.departamento_puesto || item.rol || ''
      }
    },

    construirMapaNombrePorCualquierId(filasReferenciaNombre) {
      const mapa = new Map()

      ;(Array.isArray(filasReferenciaNombre) ? filasReferenciaNombre : []).forEach((row) => {
        const normalizado = this.normalizarUsuario(row)
        const etiqueta = normalizado.usuario_registro
        const posiblesIds = [
          row && row.idusuario,
          row && row.id_usuario,
          row && row.iderp,
          row && row.id,
          row && row.usuario_registro,
          normalizado.idusuario,
          normalizado.id_usuario,
          normalizado.iderp
        ]

        posiblesIds.forEach((id) => {
          if (id == null || id === '' || Number.isNaN(Number(id)) && typeof id !== 'string') return
          const llave = String(id)
          const actual = mapa.get(llave)
          if (this.esEtiquetaMasLegible(etiqueta, actual)) {
            mapa.set(llave, etiqueta)
          } else if (!actual && etiqueta) {
            mapa.set(llave, etiqueta)
          }
        })
      })

      return mapa
    },

    combinarEtiquetasUsuarios(usuariosCatalogoNorm, filasReferenciaNombre) {
      const mapa = this.construirMapaNombrePorCualquierId(filasReferenciaNombre)
      return usuariosCatalogoNorm.map((u) => {
        const keyRaw = this.idParaSelectUsuario(u)
        if (keyRaw == null || keyRaw === '') return u
        const key = String(keyRaw)
        const mejor = mapa.get(key)
        if (mejor) return { ...u, usuario_registro: mejor, nombre_completo: mejor }
        return u
      })
    },

    dedupeUsuariosPorId(lista) {
      const map = new Map()
      ;(Array.isArray(lista) ? lista : []).forEach((u) => {
        if (u == null) return
        const idSel = this.idParaSelectUsuario(u)
        if (idSel == null || idSel === '') return
        const k = String(idSel)
        if (!map.has(k)) {
          map.set(k, u)
          return
        }

        const actual = map.get(k)
        if (this.esEtiquetaMasLegible(u.usuario_registro, actual.usuario_registro)) {
          map.set(k, { ...actual, ...u })
        }
      })
      return Array.from(map.values())
    },

    fusionarListaUsuariosParaSelects(usuariosRaw, filasNombre) {
      let lista = []
      const referencias = Array.isArray(filasNombre) ? filasNombre : []

      if (referencias.length) {
        lista = this.dedupeUsuariosPorId(referencias.map((u) => this.normalizarUsuario(u)))
      }

      const ids = new Set(
        lista.map((u) => this.idParaSelectUsuario(u)).filter((v) => v != null && v !== '').map((v) => String(v))
      )

      if (Array.isArray(usuariosRaw) && usuariosRaw.length) {
        usuariosRaw.forEach((raw) => {
          const n = this.normalizarUsuario(raw)
          const idSel = this.idParaSelectUsuario(n)
          if (idSel == null || idSel === '') return
          const k = String(idSel)

          if (ids.has(k)) {
            const idx = lista.findIndex((x) => String(this.idParaSelectUsuario(x)) === k)
            if (idx >= 0) {
              const cur = lista[idx]
              if (
                this.etiquetaUsuarioGenerica(cur.usuario_registro) &&
                !this.etiquetaUsuarioGenerica(n.usuario_registro) &&
                n.usuario_registro
              ) {
                lista[idx] = {
                  ...cur,
                  ...n,
                  usuario_registro: n.usuario_registro,
                  nombre_completo: n.usuario_registro
                }
              }
            }
            return
          }

          ids.add(k)
          lista.push(n)
        })
      }

      if (!lista.length && Array.isArray(usuariosRaw) && usuariosRaw.length) {
        lista = usuariosRaw.map((u) => this.normalizarUsuario(u))
        if (referencias.length) {
          lista = this.combinarEtiquetasUsuarios(lista, referencias)
        }
      }

      lista.sort((a, b) =>
        String(a.usuario_registro || '').localeCompare(String(b.usuario_registro || ''), 'es', {
          sensitivity: 'base'
        })
      )

      return lista
    },

    disambiguarEtiquetasUsuariosDuplicados(lista) {
      const grupos = {}
      ;(Array.isArray(lista) ? lista : []).forEach((item) => {
        const llave = this.normalizarTexto(item.usuario_registro)
        if (!llave) return
        if (!grupos[llave]) grupos[llave] = []
        grupos[llave].push(item)
      })

      return (Array.isArray(lista) ? lista : []).map((item) => {
        const llave = this.normalizarTexto(item.usuario_registro)
        const grupo = grupos[llave] || []
        if (grupo.length <= 1) return item

        const idDisamb = this.idParaSelectUsuario(item)
        const sufijo = ` (#${idDisamb != null ? idDisamb : item.idusuario})`
        return {
          ...item,
          usuario_registro: `${item.usuario_registro}${sufijo}`,
          nombre_completo: `${item.usuario_registro}${sufijo}`
        }
      })
    },

    normalizarDepartamento(row) {
      return {
        ...row,
        id:
          row && row.id != null
            ? row.id
            : row && row.id_departamento != null
              ? row.id_departamento
              : row && row.idDepartamento != null
                ? row.idDepartamento
                : null,
        nombre:
          (row && (row.nombre || row.nombre_departamento || row.departamento)) || ''
      }
    },

    normalizarPlantel(row) {
      return {
        ...row,
        idplantel:
          row && row.idplantel != null
            ? row.idplantel
            : row && row.id_plantel != null
              ? row.id_plantel
              : row && row.id != null
                ? row.id
                : null,
        plantel: (row && (row.plantel || row.nombre_plantel || row.nombre)) || ''
      }
    },

    normalizarCriterioPlantilla(row, index) {
      const criterio = row || {}
      const id =
        criterio.id_criterio_catalogo != null
          ? criterio.id_criterio_catalogo
          : criterio.id_criterio != null
            ? criterio.id_criterio
            : criterio.id != null
              ? criterio.id
              : index + 1

      return {
        ...criterio,
        id,
        id_criterio_catalogo: id,
        idVisual: criterio.idVisual != null ? criterio.idVisual : null,
        seccion:
          criterio.seccion ||
          criterio.categoria ||
          this.obtenerSeccionDesdeNombre(criterio.nombre_criterio || criterio.nombre),
        nombre: criterio.nombre_criterio || criterio.nombre || `Criterio ${id}`,
        descripcion: criterio.descripcion || criterio.detalle || '',
        calificacion: criterio.calificacion != null ? criterio.calificacion : null,
        evidencia: criterio.evidencia_hallazgo || criterio.evidencia || '',
        evidencia_hallazgo: criterio.evidencia_hallazgo || criterio.evidencia || ''
      }
    },

    normalizarAuditoriaListado(row) {
      const item = row || {}
      return {
        ...item,
        id: item.id,
        id_departamento:
          item.id_departamento != null
            ? item.id_departamento
            : item.departamento != null
              ? item.departamento
              : null,
        nombre_departamento:
          item.nombre_departamento || item.departamento || item.nombreDepartamento || '',
        tipo_auditoria: item.tipo_auditoria || item.tipoAuditoria || '',
        id_auditor:
          item.id_auditor != null
            ? item.id_auditor
            : typeof item.auditor === 'number' || (typeof item.auditor === 'string' && /^\d+$/.test(item.auditor))
              ? Number(item.auditor)
              : null,
        nombre_auditor:
          this.textoNombreHumano(item.nombre_auditor) || this.textoNombreHumano(item.auditor) || '',
        id_jefe_departamento:
          item.id_jefe_departamento != null ? item.id_jefe_departamento : item.jefeDepartamento || null,
        nombre_jefe: item.nombre_jefe || item.nombre_jefe_departamento || '',
        fecha_auditoria: this.formatearFechaInput(item.fecha_auditoria || item.fecha),
        estatus: item.estatus || 'Pendiente',
        hallazgos: item.hallazgos || '',
        accion_correctiva: item.accion_correctiva || item.accionCorrectiva || '',
        id_responsable:
          item.id_responsable != null ? item.id_responsable : item.responsable != null ? item.responsable : null,
        nombre_responsable: item.nombre_responsable || '',
        fecha_compromiso: this.formatearFechaInput(item.fecha_compromiso),
        evidencia_cierre: item.evidencia_cierre != null ? item.evidencia_cierre : '',
        id_plantel:
          item.id_plantel != null ? item.id_plantel : item.idplantel != null ? item.idplantel : null,
        nombre_plantel: item.nombre_plantel || item.plantel || '',
        resultado_porcentaje:
          item.resultado_porcentaje != null ? Number(item.resultado_porcentaje) : item.resultadoPorcentaje,
        criterios: Array.isArray(item.criterios) ? item.criterios : [],
        usuario_registro:
          item.usuario_registro != null ? item.usuario_registro : item.id_usuario_creacion || item.id_auditor || null,
        id_usuario_creacion: item.id_usuario_creacion != null ? item.id_usuario_creacion : null,
        id_usuario_actualizacion: item.id_usuario_actualizacion != null ? item.id_usuario_actualizacion : null,
        nombre_usuario_creacion:
          item.nombre_usuario_creacion || item.usuario_registro_nombre || item.nombre_auditor || ''
      }
    },

    parseHallazgosInformacionGeneral(texto) {
      const raw = texto || ''
      let modalidad = 'Inicial'
      let proceso = ''
      let resto = raw

      const lineas = raw.split(/\r?\n/)
      if (lineas.length && /^Modalidad:\s*(Inicial|Seguimiento)\s*$/i.test(lineas[0].trim())) {
        modalidad = lineas[0].replace(/^Modalidad:\s*/i, '').trim()
        resto = lineas.slice(1).join('\n').replace(/^\s+/, '')
      }

      const matchProc = resto.match(/^Proceso auditado:\s*(.*?)(?:\n\n([\s\S]*)|$)/is)
      if (matchProc) {
        proceso = (matchProc[1] || '').trim()
        resto = (matchProc[2] || '').trim()
      }

      return { modalidad, proceso, restoHallazgos: resto }
    },

    parseResumenHallazgos(texto) {
      const limpio = String(texto || '').trim()
      if (!limpio) {
        return { hallazgo1: '', hallazgo2: '', hallazgo3: '' }
      }

      const porNumero = [1, 2, 3].map((n) => {
        const re = new RegExp(`(?:^|\\n)\\s*${n}\\.\\s*(.*?)(?=(?:\\n\\s*[123]\\.\\s*)|$)`, 's')
        const m = limpio.match(re)
        return m ? String(m[1] || '').trim() : ''
      })

      if (porNumero.some((x) => x)) {
        return {
          hallazgo1: porNumero[0] || '',
          hallazgo2: porNumero[1] || '',
          hallazgo3: porNumero[2] || ''
        }
      }

      const lineas = limpio
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter(Boolean)

      return {
        hallazgo1: lineas[0] || '',
        hallazgo2: lineas[1] || '',
        hallazgo3: lineas[2] || ''
      }
    },

    construirResumenHallazgos() {
      return [
        `1. ${String(this.editedItem.hallazgo1 || '').trim()}`,
        `2. ${String(this.editedItem.hallazgo2 || '').trim()}`,
        `3. ${String(this.editedItem.hallazgo3 || '').trim()}`
      ].join('\n')
    },

    mapDetalleAFormulario(payload) {
      const item = this.extraerObjeto(payload) || {}
      const ph = this.parseHallazgosInformacionGeneral(item.hallazgos || '')
      const resumen = this.parseResumenHallazgos(ph.restoHallazgos)
      return {
        id: item.id != null ? item.id : null,
        departamento:
          item.id_departamento != null
            ? item.id_departamento
            : item.departamento != null
              ? item.departamento
              : null,
        idplantel:
          item.id_plantel != null ? item.id_plantel : item.idplantel != null ? item.idplantel : null,
        tipoAuditoria: this.tipoAuditoriaVisible(item.tipo_auditoria || item.tipoAuditoria || null),
        auditor: item.id_auditor != null ? item.id_auditor : item.auditor != null ? item.auditor : null,
        jefeDepartamento:
          item.id_jefe_departamento != null
            ? item.id_jefe_departamento
            : item.jefeDepartamento != null
              ? item.jefeDepartamento
              : null,
        fecha: this.formatearFechaInput(item.fecha_auditoria || item.fecha),
        estatus: item.estatus || 'Pendiente',
        estatusModalidad: ph.modalidad,
        procesoAuditado: ph.proceso,
        hallazgos: ph.restoHallazgos,
        hallazgo1: resumen.hallazgo1,
        hallazgo2: resumen.hallazgo2,
        hallazgo3: resumen.hallazgo3,
        accionCorrectiva: item.accion_correctiva || item.accionCorrectiva || '',
        responsable:
          item.id_responsable != null ? item.id_responsable : item.responsable != null ? item.responsable : null,
        fechaCompromiso: this.formatearFechaInput(item.fecha_compromiso || item.fechaCompromiso),
        evidenciaCierre: item.evidencia_cierre != null ? item.evidencia_cierre : ''
      }
    },

    obtenerSeccionDesdeNombre(nombre) {
      const texto = this.normalizarTexto(nombre)
      if (texto.includes('planeación') || texto.includes('planeacion')) return 'PLANEACIÓN'
      if (texto.includes('ejecución') || texto.includes('ejecucion')) return 'EJECUCIÓN'
      if (texto.includes('verificación') || texto.includes('verificacion')) return 'VERIFICACIÓN'
      if (texto.includes('actuación') || texto.includes('actuacion')) return 'ACTUACIÓN'
      return 'GENERAL'
    },

    obtenerSeccionCriterio(criterio) {
      return criterio.seccion || this.obtenerSeccionDesdeNombre(criterio.nombre)
    },

    aplicarCriteriosDesdeApi(criteriosApi) {
      const criteriosEntrada = Array.isArray(criteriosApi) ? criteriosApi : []
      const plantilla = this.criteriosVacios()

      const mapaApi = new Map()
      criteriosEntrada.forEach((item, index) => {
        const normalizado = this.normalizarCriterioPlantilla(item, index)
        const textoCanonico = this.normalizarTexto(textoPreguntaCanonicaCriterio(normalizado))
        const textoApi = this.normalizarTexto(normalizado.nombre)
        const keys = [
          normalizado.id,
          normalizado.idVisual,
          normalizado.id_criterio,
          normalizado.id_criterio_catalogo,
          item && item.id,
          item && item.idVisual,
          item && item.id_criterio,
          item && item.id_criterio_catalogo
        ].filter((valor) => valor != null && valor !== '')

        if (textoCanonico) keys.push(`txt:${textoCanonico}`)
        if (textoApi) keys.push(`txt:${textoApi}`)

        keys.forEach((key) => {
          mapaApi.set(String(key), normalizado)
        })
      })

      const fusionados = plantilla.map((base) => {
        const match =
          mapaApi.get(String(base.idVisual)) ||
          mapaApi.get(String(base.id)) ||
          mapaApi.get(String(base.id_criterio_catalogo)) ||
          mapaApi.get(String(base.id_criterio)) ||
          mapaApi.get(`txt:${this.normalizarTexto(base.nombre)}`) ||
          null

        if (!match) {
          return {
            ...base,
            calificacion: base.calificacion != null ? base.calificacion : null,
            evidencia: base.evidencia || '',
            evidencia_hallazgo: base.evidencia_hallazgo || ''
          }
        }

        return {
          ...base,
          id: base.id,
          id_criterio_catalogo: base.id_criterio_catalogo || match.id_criterio_catalogo || match.id,
          nombre:
            textoPreguntaCanonicaCriterio(base) ||
            match.nombre ||
            match.nombre_criterio ||
            base.nombre,
          descripcion: match.descripcion || base.descripcion,
          seccion: base.seccion,
          calificacion: match.calificacion != null ? match.calificacion : base.calificacion,
          evidencia: match.evidencia || match.evidencia_hallazgo || base.evidencia || '',
          evidencia_hallazgo:
            match.evidencia_hallazgo || match.evidencia || base.evidencia_hallazgo || ''
        }
      })

      const fotosMap = {}
      fusionados.forEach((item) => {
        if (!this.esCriterioFotoComentario(item)) return
        const separado = this.separarEvidenciaYFoto(item.evidencia || item.evidencia_hallazgo)
        item.evidencia = separado.comentario
        item.evidencia_hallazgo = separado.comentario
        if (separado.fotoBase64) {
          fotosMap[this.claveCriterioPhva(item)] = separado.fotoBase64
        }
      })

      this.fotosEvidenciaPhva = fotosMap

      this.criterios = fusionados
      return fusionados
    },

    resolverPuntosCalificacion(calificacion) {
      if (calificacion === '1 - No cumple') return 1
      if (calificacion === '2 - Parcial') return 2
      if (calificacion === '3 - Cumple totalmente') return 3
      return null
    },

    calcularResultadoPorcentaje(criterios) {
      const lista = Array.isArray(criterios) ? criterios : []
      let puntos = 0
      let maximo = 0

      lista.forEach((item) => {
        const calificacion =
          item.calificacion != null
            ? item.calificacion
            : item.calificacion_phva != null
              ? item.calificacion_phva
              : null

        const puntaje = this.resolverPuntosCalificacion(calificacion)
        if (puntaje == null) return
        puntos += puntaje
        maximo += 3
      })

      if (!maximo) return 0
      return Number(((puntos / maximo) * 100).toFixed(2))
    },

    formatPorcentaje(valor) {
      if (valor == null || valor === '' || Number.isNaN(Number(valor))) return '0.00%'
      return `${Number(valor).toFixed(2)}%`
    },

    getTipoColor(tipo) {
      return tipo === 'Auditoría 5S' ? 'orange' : 'blue'
    },

    nombrePlantel(id, fallback) {
      if (id != null && this.mapaNombrePlantelPorId[String(id)]) {
        return this.mapaNombrePlantelPorId[String(id)]
      }
      return fallback || ''
    },

    nombreDepartamento(id, fallback) {
      if (id != null && id !== '') {
        const match = (this.departamentos || []).find((item) => String(item.id) === String(id))
        if (match && match.nombre) return match.nombre
      }
      return fallback || ''
    },

    obtenerNombreUsuario(id, fallback) {
      if (id != null && this.mapaNombreUsuarioPorId[String(id)]) {
        return this.mapaNombreUsuarioPorId[String(id)]
      }
      return fallback || ''
    },

    textoBusquedaAuditoria(item) {
      return this.normalizarTexto(
        [
          item.id,
          item.departamento,
          item.nombrePlantel,
          item.tipoAuditoria,
          item.auditor,
          item.jefeDepartamento,
          item.responsable,
          item.estatus,
          item.usuario_registro_nombre,
          item.fecha,
          this.formatPorcentaje(item.resultadoPorcentaje)
        ].join(' ')
      )
    },

    textoBusquedaControlInterno(item) {
      return this.normalizarTexto(
        [
          item.id,
          item.objetivo,
          item.departamento,
          item.dirigidoA,
          item.nombrePlantel,
          item.responsablePlantel,
          item.fechaAuditoria
        ].join(' ')
      )
    },

    construirQueryAuditorias() {
      const query = {
        tipo_auditoria: this.filtros.tipoAuditoria || undefined,
        estatus: this.filtros.estatus || undefined,
        id_departamento:
          this.filtros.departamento != null && this.filtros.departamento !== ''
            ? this.filtros.departamento
            : undefined,
        id_plantel:
          this.filtros.plantel != null && this.filtros.plantel !== '' ? this.filtros.plantel : undefined,
        id_auditor:
          this.filtros.colaborador != null && this.filtros.colaborador !== ''
            ? this.filtros.colaborador
            : undefined,
        fecha_inicio: this.filtros.fechaini || undefined,
        fecha_fin: this.filtros.fechafin || undefined,
        page: 1,
        per_page: 500
      }

      Object.keys(query).forEach((key) => {
        if (query[key] === undefined || query[key] === null || query[key] === '') {
          delete query[key]
        }
      })

      return query
    },

    construirQueryControlInterno() {
      const query = {
        id_departamento:
          this.filtros.departamento != null && this.filtros.departamento !== ''
            ? this.filtros.departamento
            : undefined,
        id_plantel:
          this.filtros.plantel != null && this.filtros.plantel !== '' ? this.filtros.plantel : undefined,
        id_colaborador:
          this.filtros.colaborador != null && this.filtros.colaborador !== ''
            ? this.filtros.colaborador
            : undefined,
        fecha_inicio: this.filtros.fechaini || undefined,
        fecha_fin: this.filtros.fechafin || undefined,
        page: 1,
        per_page: 500
      }

      Object.keys(query).forEach((key) => {
        if (query[key] === undefined || query[key] === null || query[key] === '') {
          delete query[key]
        }
      })

      return query
    },

    async cargarCatalogos() {
      let responseUsuariosCatalogo = { data: [] }
      this.usuariosCatalogoEsEndpointAuditoria = false
      try {
        responseUsuariosCatalogo = await this.$http.get('catalogs/usuarios/auditoria')
        this.usuariosCatalogoEsEndpointAuditoria = true
      } catch (error) {
        responseUsuariosCatalogo = await this.$http.get('catalogs/usuarios').catch(() => ({ data: [] }))
      }

      const [
        responseDepartamentos,
        responsePlanteles,
        responseCriterios,
        responseUsuariosAll,
        responseUsuariosAllErp
      ] = await Promise.all([
        this.$http.get('catalogs/departamentos').catch(() => ({ data: [] })),
        this.$http.get('catalogs/planteles').catch(() => ({ data: [] })),
        this.$http.get('catalogs/auditorias/criterios').catch(() => ({ data: [] })),
        this.$http.get('usuarios.all').catch(() => ({ data: [] })),
        this.$http.get('usuarios.all.erp').catch(() => ({ data: [] }))
      ])

      this.departamentos = this.extraerArray(responseDepartamentos)
        .map((item) => this.normalizarDepartamento(item))
        .sort((a, b) => String(a.nombre).localeCompare(String(b.nombre), 'es', { sensitivity: 'base' }))

      this.planteles = this.extraerArray(responsePlanteles)
        .map((item) => this.normalizarPlantel(item))
        .sort((a, b) => String(a.plantel).localeCompare(String(b.plantel), 'es', { sensitivity: 'base' }))

      const rawUsuariosCatalogo = this.extraerArray(responseUsuariosCatalogo)
      const rawUsuariosAll = this.extraerArray(responseUsuariosAll)
      const rawUsuariosAllErp = this.extraerArray(responseUsuariosAllErp)

      this.idsUsuariosInactivos = this.obtenerMapaIdsUsuariosInactivos([
        rawUsuariosCatalogo,
        rawUsuariosAll,
        rawUsuariosAllErp
      ])

      this.usuariosCatalogo = rawUsuariosCatalogo.filter((u) => this.filaUsuarioActivoParaSelect(u))
      this.usuariosAll = rawUsuariosAll.filter((u) => this.filaUsuarioActivoParaSelect(u))
      this.usuariosAllErp = rawUsuariosAllErp.filter((u) => this.filaUsuarioActivoParaSelect(u))

      this.idsUsuariosPermitidosEnSelects = this.recopilarIdsUsuariosPermitidosDesdeCatalogosCargados([
        this.usuariosCatalogo,
        this.usuariosAll,
        // Importante: `usuarios.all.erp` trae los `idusuario` del nuevo ERP (FK de auditorías).
        // Si no lo incluimos, se ocultan filas al validar "usuarios activos" en la tabla.
        this.usuariosAllErp
      ])

      const criteriosApi = this.extraerArray(responseCriterios)
      this.criteriosPlantilla = criteriosApi.length
        ? criteriosApi.map((item, index) => this.normalizarCriterioPlantilla(item, index))
        : this.criteriosVacios()
    },

    async ensureCriteriosPlantilla() {
      if (this.criteriosPlantilla.length) {
        return this.criteriosPlantilla
      }

      try {
        const response = await this.$http.get('catalogs/auditorias/criterios')
        const lista = this.extraerArray(response)
        this.criteriosPlantilla = lista.length
          ? lista.map((item, index) => this.normalizarCriterioPlantilla(item, index))
          : this.criteriosVacios()
      } catch (error) {
        this.criteriosPlantilla = this.criteriosVacios()
      }

      return this.criteriosPlantilla
    },

    dedupeAuditoriasListadoPorId(filas) {
      const visto = new Set()
      return (Array.isArray(filas) ? filas : []).filter((row) => {
        if (!row || row.id == null || row.id === '') return true
        const k = String(row.id)
        if (visto.has(k)) return false
        visto.add(k)
        return true
      })
    },

    async obtenerAuditorias() {
      this.cargandoAuditorias = true

      try {
        const response = await this.$http.get('auditorias', {
          params: this.construirQueryAuditorias()
        })

        const normalizadas = this.extraerArray(response).map((item) => this.normalizarAuditoriaListado(item))
        this.auditorias = this.dedupeAuditoriasListadoPorId(normalizadas)
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudieron cargar las auditorías.'
        this.validarErrorDirecto(mensaje)
        this.auditorias = []
      } finally {
        this.cargandoAuditorias = false
      }
    },

    async obtenerControlInternoAuditorias() {
      try {
        const response = await this.$http.get('auditorias/control-interno', {
          params: this.construirQueryControlInterno()
        })

        this.controlInternoAuditorias = this.extraerArray(response)
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudieron cargar las auditorías de control interno.'
        this.validarErrorDirecto(mensaje)
        this.controlInternoAuditorias = []
      }
    },

    async obtenerReporteDepartamentos() {
      try {
        const response = await this.$http.get('auditorias/reporte/departamentos', {
          params: this.construirQueryAuditorias()
        })

        this.reporteAuditorias = this.extraerArray(response).map((item) => ({
          ...item,
          id_departamento:
            item.id_departamento != null
              ? item.id_departamento
              : item.id != null
                ? item.id
                : null,
          departamento: item.nombre_departamento || item.departamento || '',
          auditorias5s:
            item.auditorias_5s != null ? Number(item.auditorias_5s) : Number(item.auditorias5s || 0),
          auditoriasProcesos:
            item.auditorias_procesos != null
              ? Number(item.auditorias_procesos)
              : Number(item.auditoriasProcesos || 0),
          promedioResultado:
            item.promedio_resultado != null
              ? Number(item.promedio_resultado)
              : Number(item.promedioResultado || 0)
        }))
      } catch (error) {
        this.reporteAuditorias = []
      }
    },

    async initialize() {
      this.cargar = true
      try {
        await this.cargarCatalogos()
        await Promise.all([
          this.obtenerAuditorias(),
          this.obtenerReporteDepartamentos(),
          this.obtenerControlInternoAuditorias()
        ])
      } finally {
        this.cargar = false
      }
    },

    aplicarDefaultsAuditoriaSiFaltan() {
      if (!this.editedItem.tipoAuditoria && this.tiposAuditoriaNombres && this.tiposAuditoriaNombres.length) {
        this.editedItem.tipoAuditoria = this.tiposAuditoria[0] ? this.tiposAuditoria[0].nombre : null
      }
      if (!this.editedItem.procesoAuditado && this.editedItem.tipoAuditoria) {
        this.editedItem.procesoAuditado = this.editedItem.tipoAuditoria
      }
      if (!this.editedItem.estatusModalidad || !ESTATUS_VALIDOS.includes(this.editedItem.estatusModalidad)) {
        this.editedItem.estatusModalidad = 'Inicial'
      }
      this.editedItem.estatus = this.editedItem.estatusModalidad
      if (
        (this.editedItem.idplantel == null || this.editedItem.idplantel === '') &&
        this.planteles &&
        this.planteles.length
      ) {
        this.editedItem.idplantel = this.planteles[0].idplantel
      }
      if (
        (this.editedItem.responsable == null || this.editedItem.responsable === '') &&
        this.editedItem.auditor != null &&
        this.editedItem.auditor !== ''
      ) {
        this.editedItem.responsable = this.idResponsableSelectDesdeIdUsuarioOAuditor(this.editedItem.auditor)
      }
      if (this.criterios && this.criterios.length) {
        this.criterios.forEach((c) => {
          if (c.calificacion == null || c.calificacion === '') {
            c.calificacion = 'N/A'
          }
        })
      }
    },

    validarFormularioAuditoria() {
      this.aplicarDefaultsAuditoriaSiFaltan()

      if (this.editedItem.departamento == null || this.editedItem.departamento === '') {
        this.validarErrorDirecto('Selecciona el departamento o área.')
        return false
      }

      if (this.editedItem.auditor == null || this.editedItem.auditor === '') {
        this.validarErrorDirecto('Selecciona el auditor.')
        return false
      }

      if (this.editedItem.jefeDepartamento == null || this.editedItem.jefeDepartamento === '') {
        this.validarErrorDirecto('Selecciona el jefe de departamento.')
        return false
      }

      if (!this.editedItem.fecha) {
        this.validarErrorDirecto('Selecciona la fecha de auditoría.')
        return false
      }

      if (this.editedItem.fecha > this.fechaMaxima) {
        this.validarErrorDirecto('La fecha de auditoría no puede ser mayor a hoy.')
        return false
      }

      if (
        !this.editedItem.estatusModalidad ||
        !['Inicial', 'Seguimiento'].includes(this.editedItem.estatusModalidad)
      ) {
        this.validarErrorDirecto('Selecciona el estatus (Inicial o Seguimiento).')
        return false
      }

      if (!this.editedItem.tipoAuditoria || !this.tiposAuditoriaNombres.includes(this.editedItem.tipoAuditoria)) {
        this.validarErrorDirecto('No hay tipo de auditoría disponible.')
        return false
      }

      if (this.editedItem.idplantel == null || this.editedItem.idplantel === '') {
        this.validarErrorDirecto('No hay plantel disponible; contacta al administrador.')
        return false
      }

      if (this.editedItem.responsable == null || this.editedItem.responsable === '') {
        this.validarErrorDirecto('Selecciona el responsable del plan de acción.')
        return false
      }

      if (!this.criterios.length) {
        this.validarErrorDirecto('No hay criterios disponibles para guardar la auditoría.')
        return false
      }

      const criterioSinCalificacion = this.criterios.find(
        (item) => !item.calificacion || !this.calificacionesValidas.includes(item.calificacion)
      )

      if (criterioSinCalificacion) {
        this.validarErrorDirecto('Los criterios no pudieron inicializarse correctamente.')
        return false
      }

      return true
    },

    construirPayloadAuditoria() {
      const idSesion = this.obtenerIdSesion()
      const partesCabecera = []
      if (this.editedItem.estatusModalidad) {
        partesCabecera.push(`Modalidad: ${this.editedItem.estatusModalidad}`)
      }
      const procesoAuditado = String(this.editedItem.procesoAuditado || this.editedItem.tipoAuditoria || '').trim()
      if (procesoAuditado) {
        partesCabecera.push(`Proceso auditado: ${procesoAuditado}`)
      }
      const prefHallazgos = partesCabecera.length ? `${partesCabecera.join('\n')}\n\n` : ''
      const resumenHallazgos = this.construirResumenHallazgos()

      // Mapear cada criterio con su sección para agregar evidencia general
      const seccionPorCriterio = {}
      this.criterios.forEach((c) => {
        const seccion = c.seccion || ''
        if (!seccionPorCriterio[seccion]) {
          seccionPorCriterio[seccion] = []
        }
        seccionPorCriterio[seccion].push(c)
      })

      const payload = {
        id_departamento: this.editedItem.departamento,
        tipo_auditoria: this.tipoAuditoriaParaBackend(this.editedItem.tipoAuditoria),
        id_auditor: this.resolverIdUsuarioFkParaPayload(this.editedItem.auditor, false),
        // Igual que responsable: la FK en auditorías valida contra catálogo ERP (iderp / idusuario),
        // así que forzamos a usar `iderp` cuando esté disponible.
        // En UI guardamos `idusuario` (PK nuevo ERP); el backend ya normaliza si llega `iderp`.
        id_jefe_departamento: this.resolverIdUsuarioFkParaPayload(this.editedItem.jefeDepartamento, false),
        fecha_auditoria: this.editedItem.fecha,
        estatus: this.editedItem.estatusModalidad || this.editedItem.estatus || 'Inicial',
        hallazgos: prefHallazgos + resumenHallazgos,
        accion_correctiva: this.editedItem.accionCorrectiva || '',
        id_responsable: this.resolverIdUsuarioFkParaPayload(this.editedItem.responsable, true),
        fecha_compromiso: this.editedItem.fechaCompromiso || null,
        evidencia_cierre:
          this.editedItem.evidenciaCierre != null &&
          String(this.editedItem.evidenciaCierre).trim() !== ''
            ? this.editedItem.evidenciaCierre
            : null,
        id_plantel: this.editedItem.idplantel,
        criterios: this.criterios.map((item) => {
          // Obtener evidencia general para la sección de este criterio
          const seccionDelCriterio = item.seccion || ''
          const evidenciaGeneral = this.evidenciasGeneralesPhva[seccionDelCriterio] || ''
          const fotoGeneral = this.obtenerFotoEvidenciaGeneral(seccionDelCriterio)
          
          // Combinar evidencia individual con general
          const evidenciaIndividual = item.evidencia || item.evidencia_hallazgo || ''
          const evidenciaFinal = [
            evidenciaIndividual,
            evidenciaGeneral
          ].filter((e) => e && String(e).trim())
            .join('\n---\n')

          // Construir evidencia con foto (individual o general)
          let evidenciaConFoto = evidenciaFinal
          if (this.esCriterioFotoComentario(item)) {
            evidenciaConFoto = this.construirEvidenciaConFoto(
              evidenciaFinal || '',
              this.obtenerFotoEvidencia(item)
            )
          } else if (fotoGeneral) {
            evidenciaConFoto = this.construirEvidenciaConFoto(
              evidenciaFinal || '',
              fotoGeneral
            )
          }

          return {
            evidencia_hallazgo: evidenciaConFoto || '',
            id_criterio: item.id_criterio_catalogo || item.id,
            nombre_criterio: item.nombre,
            descripcion: item.descripcion,
            calificacion: item.calificacion
          }
        })
      }

      if (idSesion != null) {
        if (this.editedItem.id) {
          payload.id_usuario_actualizacion = idSesion
        } else {
          payload.id_usuario_creacion = idSesion
          payload.id_usuario_actualizacion = idSesion
        }
      }

      return payload
    },

    openDialogActivo() {
      if (this.esTabEvaluacionPersonal) {
        return this.openDialog()
      }
      this.openDialogControlInterno()
      return null
    },

    openDialogControlInterno() {
      this.editedControlInternoIndex = -1
      this.editedControlInternoItem = crearDefaultControlInternoItem()
      this.dialogControlInterno = true
    },

    mapControlInternoAFormulario(item) {
      const row = item || {}
      return {
        id: row.id != null ? row.id : null,
        objetivo: row.objetivo || '',
        departamento:
          row.id_departamento != null
            ? row.id_departamento
            : row.departamento != null
              ? row.departamento
              : null,
        dirigidoA:
          row.id_dirigido_a != null
            ? row.id_dirigido_a
            : row.dirigidoA != null
              ? row.dirigidoA
              : null,
        idplantel:
          row.id_plantel != null
            ? row.id_plantel
            : row.idplantel != null
              ? row.idplantel
              : null,
        responsablePlantel:
          row.id_responsable_plantel != null
            ? this.idResponsableSelectDesdeIdUsuarioOAuditor(row.id_responsable_plantel) || row.id_responsable_plantel
            : row.responsablePlantel != null
              ? row.responsablePlantel
              : null,
        fechaAuditoria: this.formatearFechaInput(row.fecha_auditoria || row.fechaAuditoria),
        criterios: this.normalizarCriteriosControlInterno(row.criterios),
        salones: this.normalizarSalonesControlInterno(row.salones),
        observacionesSalones: row.observacionesSalones || row.observaciones_salones || '',
        corte: this.normalizarCorteControlInterno(row.corte),
        vestimenta: this.normalizarVestimentaControlInterno(row.vestimenta),
        riAtencionAlumno: this.normalizarRiAtencionAlumnoControlInterno(row.riAtencionAlumno || row.ri_atencion_alumno),
        metodologia5s: this.normalizarMetodologia5sControlInterno(row.metodologia5s || row.metodologia_5s),
        cierreAuditoria: this.normalizarCierreAuditoriaControlInterno(row.cierreAuditoria || row.cierre_auditoria)
      }
    },

    normalizarCriteriosControlInterno(criterios) {
      const criteriosEntrada = Array.isArray(criterios) ? criterios : []
      const mapa = new Map()
      criteriosEntrada.forEach((item) => {
        if (!item || item.id == null) return
        mapa.set(String(item.id), item)
      })

      return clonarCriteriosControlInterno().map((base) => {
        const match = mapa.get(String(base.id))
        return {
          ...base,
          resultado: match && match.resultado ? match.resultado : null
        }
      })
    },

    normalizarSalonesControlInterno(salones) {
      const entrada = Array.isArray(salones) ? salones : []
      const mapa = new Map()
      entrada.forEach((item) => {
        if (!item || item.salon == null) return
        mapa.set(String(item.salon), item)
      })

      return clonarSalonesControlInterno().map((base) => ({
        ...base,
        ...(mapa.get(String(base.salon)) || {})
      }))
    },

    normalizarListaResultadoControlInterno(listaBase, listaEntrada) {
      const entrada = Array.isArray(listaEntrada) ? listaEntrada : []
      const mapa = new Map()
      entrada.forEach((item) => {
        if (!item || item.id == null) return
        mapa.set(String(item.id), item)
      })

      return clonarCriteriosResultado(listaBase).map((base) => ({
        ...base,
        ...(mapa.get(String(base.id)) || {})
      }))
    },

    normalizarCorteControlInterno(corte) {
      const item = corte || {}
      return {
        encargada: this.normalizarValorSelectNumerico(item.encargada),
        recepcionTurno: this.normalizarValorSelectNumerico(item.recepcionTurno || item.recepcion_turno),
        criterios: this.normalizarListaResultadoControlInterno(CORTE_CONTROL_INTERNO_BASE, item.criterios),
        observaciones: item.observaciones || ''
      }
    },

    normalizarVestimentaControlInterno(vestimenta) {
      const item = vestimenta || {}
      const entrada = Array.isArray(item.filas) ? item.filas : []
      const mapa = new Map()
      entrada.forEach((fila) => {
        if (!fila || !fila.personal) return
        mapa.set(String(fila.personal), fila)
      })

      return {
        filas: VESTIMENTA_CONTROL_INTERNO_BASE.map((base) => ({
          ...base,
          ...(mapa.get(String(base.personal)) || {})
        })),
        observaciones: item.observaciones || ''
      }
    },

    normalizarRiAtencionAlumnoControlInterno(ri) {
      const item = ri || {}
      return {
        encargada: item.encargada || '',
        encargadaCriterios: this.normalizarListaResultadoControlInterno(
          RI_ENCARGADA_CONTROL_INTERNO_BASE,
          item.encargadaCriterios || item.encargada_criterios
        ),
        encargadaObservaciones: item.encargadaObservaciones || item.encargada_observaciones || '',
        recepcionCriterios: this.normalizarListaResultadoControlInterno(
          RI_RECEPCION_CONTROL_INTERNO_BASE,
          item.recepcionCriterios || item.recepcion_criterios
        ),
        recepcionObservaciones: item.recepcionObservaciones || item.recepcion_observaciones || ''
      }
    },

    normalizarMetodologia5sControlInterno(metodologia) {
      const item = metodologia || {}
      return {
        criterios: this.normalizarListaResultadoControlInterno(METODOLOGIA_5S_CONTROL_INTERNO_BASE, item.criterios),
        nivelGeneral: item.nivelGeneral || item.nivel_general || null,
        climaGeneral: item.climaGeneral || item.clima_general || null,
        comunicacion: item.comunicacion || null,
        organizacionTurnos: item.organizacionTurnos || item.organizacion_turnos || null,
        liderazgo: item.liderazgo || null,
        operacion: item.operacion || null
      }
    },

    normalizarFilasObservacionesControlInterno(filas, cantidad) {
      const entrada = Array.isArray(filas) ? filas : []
      const base = crearFilasObservacionesControlInterno(cantidad)
      entrada.slice(0, cantidad).forEach((fila, index) => {
        base[index] = {
          observacion: fila && fila.observacion ? fila.observacion : '',
          departamento: fila && fila.departamento ? fila.departamento : ''
        }
      })
      return base
    },

    normalizarCierreAuditoriaControlInterno(cierre) {
      const item = cierre || {}
      return {
        principalesHallazgos: this.normalizarFilasObservacionesControlInterno(
          item.principalesHallazgos || item.principales_hallazgos,
          2
        ),
        areasOportunidad: this.normalizarFilasObservacionesControlInterno(
          item.areasOportunidad || item.areas_oportunidad,
          2
        ),
        fortalezasDetectadas: this.normalizarFilasObservacionesControlInterno(
          item.fortalezasDetectadas || item.fortalezas_detectadas,
          2
        ),
        auditorFirma: this.normalizarValorSelectNumerico(item.auditorFirma || item.auditor_firma),
        responsablePlantelFirma: this.normalizarValorSelectNumerico(
          item.responsablePlantelFirma || item.responsable_plantel_firma
        ),
        fechaFirma: this.formatearFechaInput(item.fechaFirma || item.fecha_firma)
      }
    },

    marcarCriterioControlInterno(criterio, resultado) {
      if (!criterio) return
      criterio.resultado = criterio.resultado === resultado ? null : resultado
    },

    toggleBooleanControlInterno(item, campo) {
      if (!item || !campo) return
      item[campo] = !item[campo]
    },

    seleccionarValorControlInterno(item, campo, valor) {
      if (!item || !campo) return
      item[campo] = item[campo] === valor ? null : valor
    },

    validarFormularioControlInterno() {
      if (!String(this.editedControlInternoItem.objetivo || '').trim()) {
        this.validarErrorDirecto('Captura el objetivo de la auditoría.')
        return false
      }

      if (this.editedControlInternoItem.departamento == null || this.editedControlInternoItem.departamento === '') {
        this.validarErrorDirecto('Selecciona el departamento.')
        return false
      }

      if (this.editedControlInternoItem.dirigidoA == null || this.editedControlInternoItem.dirigidoA === '') {
        this.validarErrorDirecto('Selecciona a quién va dirigida la auditoría.')
        return false
      }

      if (this.editedControlInternoItem.idplantel == null || this.editedControlInternoItem.idplantel === '') {
        this.validarErrorDirecto('Selecciona el plantel.')
        return false
      }

      if (
        this.editedControlInternoItem.responsablePlantel == null ||
        this.editedControlInternoItem.responsablePlantel === ''
      ) {
        this.validarErrorDirecto('Selecciona el responsable del plantel.')
        return false
      }

      if (!this.editedControlInternoItem.fechaAuditoria) {
        this.validarErrorDirecto('Selecciona la fecha de auditoría.')
        return false
      }

      if (this.editedControlInternoItem.fechaAuditoria > this.fechaMaxima) {
        this.validarErrorDirecto('La fecha de auditoría no puede ser mayor a hoy.')
        return false
      }

      return true
    },

    construirPayloadControlInterno() {
      const idSesion = this.obtenerIdSesion()
      const payload = {
        id: this.editedControlInternoItem.id,
        objetivo: String(this.editedControlInternoItem.objetivo || '').trim(),
        id_departamento: this.editedControlInternoItem.departamento,
        id_dirigido_a: this.resolverIdUsuarioFkParaPayload(this.editedControlInternoItem.dirigidoA, false),
        id_plantel: this.editedControlInternoItem.idplantel,
        id_responsable_plantel: this.resolverIdUsuarioFkParaPayload(
          this.editedControlInternoItem.responsablePlantel,
          true
        ),
        fecha_auditoria: this.editedControlInternoItem.fechaAuditoria,
        criterios: (this.editedControlInternoItem.criterios || []).map((item) => ({
          id: item.id,
          seccion: item.seccion,
          criterio: item.criterio,
          resultado: item.resultado || null
        })),
        salones: (this.editedControlInternoItem.salones || []).map((item) => ({ ...item })),
        observacionesSalones: this.editedControlInternoItem.observacionesSalones || '',
        corte: {
          ...this.editedControlInternoItem.corte,
          criterios: (this.editedControlInternoItem.corte.criterios || []).map((item) => ({ ...item }))
        },
        vestimenta: {
          ...this.editedControlInternoItem.vestimenta,
          filas: (this.editedControlInternoItem.vestimenta.filas || []).map((item) => ({ ...item }))
        },
        riAtencionAlumno: {
          ...this.editedControlInternoItem.riAtencionAlumno,
          encargadaCriterios: (this.editedControlInternoItem.riAtencionAlumno.encargadaCriterios || []).map((item) => ({
            ...item
          })),
          recepcionCriterios: (this.editedControlInternoItem.riAtencionAlumno.recepcionCriterios || []).map((item) => ({
            ...item
          }))
        },
        metodologia5s: {
          ...this.editedControlInternoItem.metodologia5s,
          criterios: (this.editedControlInternoItem.metodologia5s.criterios || []).map((item) => ({ ...item }))
        },
        cierreAuditoria: {
          ...this.editedControlInternoItem.cierreAuditoria,
          principalesHallazgos: (this.editedControlInternoItem.cierreAuditoria.principalesHallazgos || []).map(
            (item) => ({ ...item })
          ),
          areasOportunidad: (this.editedControlInternoItem.cierreAuditoria.areasOportunidad || []).map((item) => ({
            ...item
          })),
          fortalezasDetectadas: (this.editedControlInternoItem.cierreAuditoria.fortalezasDetectadas || []).map(
            (item) => ({ ...item })
          )
        }
      }

      if (idSesion != null) {
        if (payload.id) {
          payload.id_usuario_actualizacion = idSesion
        } else {
          payload.id_usuario_creacion = idSesion
          payload.id_usuario_actualizacion = idSesion
        }
      }

      return payload
    },

    siguienteIdControlInterno() {
      const maximo = (this.controlInternoAuditorias || []).reduce((max, item) => {
        const id = Number(item && item.id)
        return !Number.isNaN(id) && id > max ? id : max
      }, 0)
      return maximo + 1
    },

    async editControlInternoItem(item) {
      this.cargar = true
      try {
        this.editedControlInternoIndex = this.controlInternoAuditorias.findIndex(
          (row) => String(row.id) === String(item.id)
        )
        const responseDetalle = await this.$http.get(`auditorias/control-interno/${item.id}`)
        const detalle = this.extraerObjeto(responseDetalle)
        this.editedControlInternoItem = this.mapControlInternoAFormulario(detalle)
        this.asegurarUsuarioEnCatalogoLocal(detalle && detalle.id_dirigido_a, detalle && detalle.nombre_dirigido_a)
        this.asegurarUsuarioEnCatalogoLocal(
          detalle && detalle.id_responsable_plantel,
          detalle && detalle.nombre_responsable_plantel
        )
        const cierre = detalle && (detalle.cierreAuditoria || detalle.cierre_auditoria)
        this.asegurarUsuarioEnCatalogoLocal(cierre && (cierre.auditorFirma || cierre.auditor_firma), '')
        this.asegurarUsuarioEnCatalogoLocal(
          cierre && (cierre.responsablePlantelFirma || cierre.responsable_plantel_firma),
          ''
        )
        this.dialogControlInterno = true
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo cargar el detalle de control interno.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    async deleteControlInternoItem(item) {
      if (!confirm('¿Estás seguro de que deseas eliminar esta auditoría de control interno?')) return

      this.cargar = true
      try {
        await this.$http.delete(`auditorias/control-interno/${item.id}`)
        this.validarSuccess('Auditoría de control interno eliminada correctamente.')
        await this.obtenerControlInternoAuditorias()
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo eliminar la auditoría de control interno.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    closeControlInterno() {
      this.dialogControlInterno = false
      this.$nextTick(() => {
        this.editedControlInternoItem = crearDefaultControlInternoItem()
        this.editedControlInternoIndex = -1
      })
    },

    async saveControlInterno() {
      if (!this.validarFormularioControlInterno()) return

      this.cargar = true
      try {
        const payload = this.construirPayloadControlInterno()
        if (payload.id) {
          await this.$http.put(`auditorias/control-interno/${payload.id}`, payload)
          this.validarSuccess('Auditoría de control interno actualizada correctamente.')
        } else {
          await this.$http.post('auditorias/control-interno', payload)
          this.validarSuccess('Auditoría de control interno guardada correctamente.')
        }

        this.closeControlInterno()
        await this.obtenerControlInternoAuditorias()
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo guardar la auditoría de control interno.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    async openDialog() {
      this.cargar = true
      try {
        this.editedIndex = -1
        this.editedItem = crearDefaultItem()
        this.fotosEvidenciaPhva = {}
        this.evidenciasGeneralesPhva = {}
        this.fotosEvidenciaGeneralesPhva = {}
        await this.ensureCriteriosPlantilla()
        this.aplicarCriteriosDesdeApi([])

        if (!this.criterios.length) {
          this.validarErrorDirecto('No se encontraron criterios para inicializar la auditoría.')
          return
        }

        this.dialog = true
      } finally {
        this.cargar = false
      }
    },

    async editItem(item) {
      this.cargar = true

      try {
        this.editedIndex = this.auditorias.findIndex((row) => String(row.id) === String(item.id))

        const [_, responseDetalle] = await Promise.all([
          this.ensureCriteriosPlantilla(),
          this.$http.get(`auditorias/${item.id}`)
        ])

        const detalle = this.extraerObjeto(responseDetalle)
        this.editedItem = this.mapDetalleAFormulario(detalle)

        // Permite editar registros aunque el usuario no venga en `catalogs/usuarios`,
        // siempre que el id exista en BD (la FK ya lo garantiza en datos consistentes).
        this.asegurarUsuarioEnCatalogoLocal(detalle && detalle.id_auditor, detalle && detalle.nombre_auditor)
        this.asegurarUsuarioEnCatalogoLocal(
          detalle && detalle.id_jefe_departamento,
          detalle && (detalle.nombre_jefe || detalle.nombre_jefe_departamento)
        )
        this.asegurarUsuarioEnCatalogoLocal(detalle && detalle.id_responsable, detalle && detalle.nombre_responsable)
        this.asegurarUsuarioEnCatalogoLocal(detalle && detalle.id_usuario_creacion, detalle && detalle.nombre_usuario_creacion)
        this.asegurarUsuarioEnCatalogoLocal(
          detalle && detalle.id_usuario_actualizacion,
          detalle && detalle.nombre_usuario_actualizacion
        )

        this.aplicarCriteriosDesdeApi(detalle && detalle.criterios)

        if (!this.criterios.length) {
          this.validarErrorDirecto('La auditoría no cuenta con criterios configurados.')
          return
        }

        this.dialog = true
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo cargar el detalle de la auditoría.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    async deleteItem(item) {
      if (!confirm('¿Estás seguro de que deseas eliminar esta auditoría?')) return

      this.cargar = true

      try {
        await this.$http.delete(`auditorias/${item.id}`)
        this.validarSuccess('Auditoría eliminada correctamente.')
        await Promise.all([this.obtenerAuditorias(), this.obtenerReporteDepartamentos()])
      } catch (error) {
        const mensaje =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo eliminar la auditoría.'
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = crearDefaultItem()
        this.editedIndex = -1
        this.fotosEvidenciaPhva = {}
        this.evidenciasGeneralesPhva = {}
        this.fotosEvidenciaGeneralesPhva = {}
        this.criterios = this.criteriosVacios()
      })
    },

    async save() {
      if (!this.validarFormularioAuditoria()) return

      this.cargar = true

      try {
        const payload = this.construirPayloadAuditoria()

        if (this.editedItem.id) {
          await this.$http.put(`auditorias/${this.editedItem.id}`, payload)
          this.validarSuccess('Auditoría actualizada correctamente.')
        } else {
          await this.$http.post('auditorias', payload)
          this.validarSuccess('Auditoría guardada correctamente.')
        }

        this.close()
        await Promise.all([this.obtenerAuditorias(), this.obtenerReporteDepartamentos()])
      } catch (error) {
        const raw =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'No se pudo guardar la auditoría.'
        const mensaje = this.interpretarErrorSqlAuditorias(raw)
        this.validarErrorDirecto(mensaje)
      } finally {
        this.cargar = false
      }
    },

    interpretarErrorSqlAuditorias(mensaje) {
      const texto = String(mensaje || '')
      if (!texto) return 'No se pudo guardar la auditoría.'

      if (texto.includes('auditorias_ibfk_2') && texto.includes('id_auditor')) {
        return 'No puedes elegir a ese usuario como auditor: no está disponible en el catálogo de ERP (usuarios).'
      }

      if (texto.includes('FOREIGN KEY') && texto.includes('id_jefe_departamento')) {
        return 'No puedes elegir a ese usuario como jefe de departamento: no está disponible en el catálogo de ERP (usuarios).'
      }

      if (texto.includes('FOREIGN KEY') && texto.includes('id_responsable')) {
        return 'No puedes elegir a ese usuario como responsable: no está disponible en el catálogo de ERP (usuarios).'
      }

      return texto
    },

    canDelete() {
      return !!this.getdatosUsuarioERPERP
    }
  },

  mounted() {
    this.initialize()
  }
}
</script>

<style scoped>
.text-sm {
  font-size: 0.875rem;
}

.shadowCard {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.auditoria-dashboard {
  display: block;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e9eef5;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04);
}

.auditoria-dashboard-header,
.auditoria-table-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.auditoria-table-header {
  justify-content: space-between;
  margin: 10px 0 6px;
  padding: 0 2px;
}

.auditoria-section-title {
  color: #263238;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.auditoria-chip {
  border: 1px solid rgba(25, 118, 210, 0.16);
  font-weight: 700;
}

.auditoria-tabs-wrap {
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
}

.auditoria-tabs {
  flex: 0 0 auto;
  width: auto;
  border: 1px solid #edf2f7;
  border-radius: 14px;
  padding: 4px;
  background: #ffffff !important;
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.05);
}

.auditoria-tabs ::v-deep .v-slide-group__content {
  gap: 6px;
}

.auditoria-tabs ::v-deep .v-tabs-slider-wrapper {
  display: none;
}

.auditoria-tab {
  flex: 0 0 auto !important;
  min-width: 40px !important;
  width: auto !important;
  max-width: 180px;
  min-height: 32px !important;
  padding: 0 14px !important;
  border: 1px solid;
  border-radius: 11px;
  font-size: 0.7rem;
  letter-spacing: 0.04em;
  opacity: 0.82;
  transition: all 0.18s ease;
}

.auditoria-tab:hover {
  opacity: 1;
  transform: translateY(-1px);
}

.auditoria-tab--evaluacion {
  background: #eef7ff !important;
  border-color: #d8ecff;
  color: #1565c0 !important;
}

.auditoria-tab--control {
  background: #fff8e8 !important;
  border-color: #ffe7b8;
  color: #ad6800 !important;
}

.auditoria-tab--evaluacion.auditoria-tab--active {
  background: #f8fcff !important;
  border-color: #90caf9;
  box-shadow: inset 0 0 0 1px rgba(33, 150, 243, 0.18);
}

.auditoria-tab--control.auditoria-tab--active {
  background: #fffdf7 !important;
  border-color: #ffd166;
  box-shadow: inset 0 0 0 1px rgba(255, 160, 0, 0.18);
}

.auditoria-tab--active {
  font-weight: 800;
  opacity: 1;
}

.auditoria-metrics {
  display: flex;
  align-items: flex-end;
  gap: 18px;
  min-height: 34px;
}

.reporte-dashboard-row {
  display: flex;
  margin-top: 4px !important;
}

.reporte-dept-card {
  min-height: 92px;
  border: 1px solid #e7edf5;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.reporte-dept-card:hover {
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.reporte-metric {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.reporte-metric-val {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
}

.auditoria-table {
  overflow: hidden;
  border: 1px solid #e8eef7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.04);
}

.auditoria-table ::v-deep thead tr {
  background: #f6f9fd;
}

.auditoria-table ::v-deep th {
  color: #546e7a !important;
  font-size: 0.72rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.auditoria-table ::v-deep tbody tr {
  transition: background-color 0.15s ease;
}

.auditoria-table ::v-deep tbody tr:hover {
  background: #f8fbff !important;
}

.auditoria-table ::v-deep td {
  border-bottom: 1px solid #eef3f8 !important;
}

.control-interno-modal-card {
  overflow: hidden;
  border-radius: 18px;
  background: #f8fafc;
}

.control-interno-modal-header {
  border-bottom: 1px solid #e7edf5;
  background:
    radial-gradient(circle at top left, rgba(33, 150, 243, 0.14), transparent 35%),
    linear-gradient(135deg, #ffffff 0%, #f7fbff 100%);
  padding: 18px 24px;
}

.control-interno-modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.control-interno-modal-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid #dbeafe;
  border-radius: 14px;
  background: #eff6ff;
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.12);
}

.control-interno-modal-title {
  color: #0f172a;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.control-interno-modal-subtitle {
  color: #64748b;
  font-size: 0.78rem;
  line-height: 1.35;
}

.control-interno-modal-id {
  padding: 6px 10px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 0.8rem;
}

.control-interno-modal-body {
  background: #f8fafc;
  padding: 18px 24px 22px !important;
}

.control-interno-modal-dashboard {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.control-interno-modal-stat {
  min-height: 76px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.05);
}

.control-interno-modal-stat .stat-label {
  display: block;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.control-interno-modal-stat .stat-value {
  display: block;
  margin-top: 8px;
  color: #0f172a;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.2;
}

.control-interno-modal-stat.stat-accent {
  border-color: #fed7aa;
  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 100%);
}

.control-interno-modal-body ::v-deep .v-input__slot {
  border-radius: 12px !important;
  box-shadow: none !important;
}

.control-interno-modal-body ::v-deep .v-text-field--filled > .v-input__control > .v-input__slot,
.control-interno-modal-body ::v-deep .v-textarea > .v-input__control > .v-input__slot {
  border: 1px solid #e2e8f0;
  background: #ffffff !important;
}

.control-interno-modal-body ::v-deep .v-input--is-focused .v-input__slot {
  border-color: #93c5fd !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.control-interno-modal-body label {
  color: #475569;
  font-weight: 700;
}

.control-interno-modal-actions {
  border-top: 1px solid #e7edf5;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 -10px 24px rgba(15, 23, 42, 0.08);
  padding: 12px 24px !important;
}

.control-interno-action-btn {
  min-width: 118px !important;
  border-radius: 10px !important;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
}

.control-interno-seccion-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 18px 0 10px;
  color: #0f172a;
  font-size: 0.95rem;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.control-interno-seccion-title::before {
  content: '';
  width: 8px;
  height: 24px;
  border-radius: 999px;
  background: linear-gradient(180deg, #38bdf8 0%, #2563eb 100%);
}

.control-interno-check-table {
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid #dbe4ef;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
}

.control-interno-check-table ::v-deep table {
  min-width: 760px;
  border-collapse: separate;
  border-spacing: 0;
}

.control-interno-check-table ::v-deep th,
.control-interno-check-table ::v-deep td {
  border-right: 1px solid #dbe4ef !important;
  border-bottom: 1px solid #dbe4ef !important;
  color: #1e293b;
  font-size: 0.82rem !important;
  vertical-align: middle;
}

.control-interno-check-table ::v-deep th:last-child,
.control-interno-check-table ::v-deep td:last-child {
  border-right: 0 !important;
}

.control-interno-check-table ::v-deep tbody tr:last-child td {
  border-bottom: 0 !important;
}

.control-interno-check-table ::v-deep th {
  background: linear-gradient(180deg, #f8fafc 0%, #eef4fb 100%);
  color: #475569;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.control-interno-check-table ::v-deep th:nth-child(2),
.control-interno-check-table ::v-deep th:nth-child(3) {
  width: 118px;
  font-size: 0.82rem !important;
}

.control-interno-check-table ::v-deep tbody tr {
  transition: background-color 0.15s ease;
}

.control-interno-check-table ::v-deep tbody tr:hover {
  background: #f8fbff;
}

.control-interno-check {
  display: inline-flex;
  margin-top: 0;
  padding-top: 0;
}

.control-interno-check ::v-deep .v-input--selection-controls__input {
  margin: 0;
}

.control-interno-check ::v-deep .v-icon {
  color: #64748b;
}

.control-interno-check ::v-deep .v-input--selection-controls__ripple {
  color: #2563eb;
}

.control-interno-nivel {
  display: grid;
  gap: 8px;
  padding: 14px;
  border: 1px solid #dbe4ef;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
}

.control-interno-nivel-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.control-interno-nivel-row strong {
  min-width: 210px;
  color: #334155;
}

.control-interno-nivel-check {
  margin: 0 !important;
  padding: 0 !important;
}

.control-interno-observaciones-table ::v-deep th:nth-child(2),
.control-interno-observaciones-table ::v-deep td:nth-child(2) {
  width: 240px;
}

.control-interno-check-table ::v-deep .v-text-field.v-text-field--solo .v-input__control {
  min-height: 34px;
}

.control-interno-check-table ::v-deep .v-text-field.v-text-field--solo .v-input__slot,
.control-interno-check-table ::v-deep .v-textarea.v-text-field--solo .v-input__slot {
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.control-interno-firmas {
  padding: 16px;
  border: 1px solid #dbe4ef;
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
}

@media (max-width: 960px) {
  .control-interno-modal-dashboard {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .control-interno-modal-header,
  .control-interno-modal-body,
  .control-interno-modal-actions {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }

  .control-interno-modal-dashboard {
    grid-template-columns: 1fr;
  }
}

.resultado-card {
  background: #fafafa;
}

.resultado-porcentaje {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.25;
}

.criterio-row {
  border-bottom: 1px solid #eeeeee;
}

.criterio-row:last-child {
  border-bottom: 0;
}

.bg-light-grey {
  background-color: #f5f5f5 !important;
}

.phva-table tbody tr td.bg-light-grey {
  border-top: 2px solid #ddd;
  border-bottom: 2px solid #ddd;
}
</style>
